<template>
	<div class="question-type" v-loading.fullscreen="loading">
		<div class="exportImport" v-if="!isBank">
			<span class="exportStyle" @click="exportData">{{$t('main.export')}}</span>
			<span class="importStyle" @click="importData">{{$t('main.import')}}</span>
		</div>
		<!-- 分组设置弹窗 -->
		<div v-if="grouping" class="mask"></div>
		<div class="details3" v-if="grouping">
			<div class="groupTitle">
				<i></i>
				<span style="font-size: 18px; color: #333333; margin: 0 auto">{{$t('main.import')}}</span>
				<i class="el-icon-close" @click="grouping = false"></i>
			</div>
			<div class="groupBox">
				<div class="groupLeft">
					<div style="width: 340px; height: auto; margin: 0 auto">
						<p class="groupLeft_title">{{$t('main.OptionsToBeGrouped')}}</p>
						<p class="groupLeft_Tips">{{$t('main.GroupedlTips')}}</p>
						<p class="groupLeft_search">
							<el-input :placeholder="$t('main.PleaseEnterKeywordSearch')" v-model="groupSearch" @input="groupSearchInput">
								<i slot="prefix" class="el-input__icon el-icon-search"></i>
							</el-input>
						</p>

						<el-checkbox-group v-if="groupSearch" v-model="checkedCities">
							<el-checkbox v-for="item in groupSearchList" :value="item" @change="clickAdd" :label="item" :key="item.oid" style="">
								<span v-text="$functions.htmlFormat(item.labelName)"></span>
							</el-checkbox>
						</el-checkbox-group>
						<el-checkbox-group v-else v-model="checkedCities">
							<el-checkbox v-for="item in optionGroup" :value="item" @change="clickAdd" :label="item" :key="item.oid" style="">
								<span v-text="$functions.htmlFormat(item.labelName)"></span>
							</el-checkbox>
						</el-checkbox-group>
					</div>
				</div>
				<div class="groupRight" style="overflow: auto">
					<div style="width: 340px; height: auto; margin: 0 auto">
						<p class="groupRight_title">
							<span>{{$t('main.GroupManagement')}}</span>
							<span style="color: #0080ff" @click="addGroup()">{{$t('main.AddGroup')}}</span>
						</p>
						<div v-for="(item, index) in groupQuery" :key="index" class="groupRight_add">
							<el-button class="groupAdd" size="mini" @click="jiaru(index)">{{$t('main.join')}}</el-button>
							<el-input size="mini" :placeholder="$t('main.GroupName')" v-model="item.groupName"></el-input>
							<el-dropdown>
								<span class="el-dropdown-link"><i class="icon wjpc-iconfont wjpc-icon-ico_open"></i></span>
								<el-dropdown-menu slot="dropdown">
									<el-dropdown-item @click.native="onUpItem(item, index)">{{$t('main.moveUp')}}</el-dropdown-item>
									<el-dropdown-item @click.native="onDownItem(item, index)">{{$t('main.MoveDown')}}</el-dropdown-item>
									<el-dropdown-item @click.native="deleItem(item, index)">{{$t('main.delete')}}</el-dropdown-item>
								</el-dropdown-menu>
							</el-dropdown>
							<div
								v-for="(item1, index) in item.optionList"
								:key="index"
								style="
                  width: 290px;
                  height: 26px;
                  line-height: 26px;
                  background: #f1f1f1;
                  font-size: 12px;
                  text-indent: 10px;
                  margin-left: 60px;
                  margin-top: 10px;
                "
							>
								<p>
									<span v-text="$functions.htmlFormat(item1.labelName)"></span>
									<i
										class="el-icon-close"
										style="float: right; line-height: 26px; padding-right: 3px"
										@click="removeOptionGroup(item.optionList, item1, index)"
									></i>
								</p>
							</div>
						</div>
					</div>
				</div>
			</div>
			<div class="group_btnBox">
				<el-button @click="grouping = false">{{$t('main.cancel')}}</el-button>
				<el-button type="primary" @click="groupSave">{{$t('main.save')}}</el-button>
			</div>
		</div>

		<!-- 题型 -->
		<div :class="{ questionType: !isBank }" style="" :style="{ marginTop: isTemplate || isBank ? '0' : '62px' }">
			<!-- <div class="aside scroll-body">
				<el-tabs v-model="activeTabsName" type="border-card">
					<el-tab-pane label="题型" name="first">
						<div class="fixedTabs">
							<QuestionTypeList
								v-if="typeObj.length > 0"
								:typeObj="typeObj"
								:type="'wj'"
								@commonTopic="selectTypeQuestion"
								@batchAddQues="batchAddQues"
							></QuestionTypeList>
						</div>
					</el-tab-pane>
					<el-tab-pane v-if="!isBank" label="题库" name="second">
						<div class="fixedTabs">
							<QuestionBankList @quesFormBand="quesFormBand" :bankType="1">
							
							</QuestionBankList>
						</div>
					</el-tab-pane>
					<el-tab-pane v-if="!isBank" label="大纲" name="third">
						<div>
							<div class="fixedSearch">
								<el-input placeholder="请输入内容" v-model="queryOutline" clearable class="input-with-select">
									<el-button slot="append" icon="el-icon-search" @click="queryQuestionOutline"></el-button>
								</el-input>
							</div>
							<div class="fixedTabsIcon-box">
								<el-tooltip class="item" effect="light" content="复制" placement="top"><i class="zxwj-iconfont zxwj-icon-fuzhi" @click="copyClick"></i></el-tooltip>
								<el-tooltip class="item" effect="light" content="粘贴" placement="top">
									<i class="zxwj-iconfont zxwj-icon-niantie1" @click="pasteClick"></i>
								</el-tooltip>
							</div>
							<div class="fixedTabsThird">
								<QuestionOutline :type="'wj'" :list="searchQuestionsList" @goAnchor="goAnchor" @copyClick="copyClick" @pasteClick="pasteClick"></QuestionOutline>
							</div>
						</div>
					</el-tab-pane>
				</el-tabs>
			</div> -->
			<div class="test-edit">
				<!-- 中间盒子 -->
				<!-- overflow-y: auto; 修改滚动条 -->
				<div
					id="wenjuan_list"
					class="wjEdit scroll-body"
					:style="{ height: rightheight + 'px' }"
					style="width: calc(100% - 300px);  float: left"
					ref="questionlist"
				>
					<div
						:style="{
							position: 'absolute',
							top: top - 40 + 'px',
							left: left + 'px',
							height: '30px',
							zIndex: 999
						}"
					>
						<table>
							<tr>
								<td class="operate_td"><i class="el-icon-picture"></i></td>
								<td class="operate_td" @click="outerVisible = true"><i class="el-icon-tickets"></i></td>
							</tr>
						</table>
					</div>
					<el-container >
						<el-main>
							<el-row :gutter="10" v-resize="handleResize" class="item_container">
								<el-row :gutter="10" style="margin-left: 40px">
									<el-col :xs="22" :sm="22" :md="22" :lg="22" :xl="22" class="item_container_title titleInput">
										<div class="wenjuan_title" @click="setActiveInput(wid + 'title')">
											<TitleEditor
												key="papertitle"
												:qid="wid + 'title'"
												:class="wid + 'title'"
												class="outline-none"
												:value="paper.title"
                    							:actionTitleEditorShow="activeInputId === wid + 'title'"
												@childValueChange="
													val => {
														paper.title = val;
													}
												"
											></TitleEditor>
										</div>
									</el-col>
								</el-row>
								<el-row :gutter="10" style="margin: 12px 0 12px 40px !important;">
									<el-col :xs="22" :sm="22" :md="22" :lg="22" :xl="22" class="item_container_title welcomInput">
										<div class="wj-content border-none" @click="setActiveInput(wid + 'depict')">
											<TitleEditor
												key="paperdepict"
												:qid="wid + 'depict'"
												:class="wid + 'depict'"
												class="outline-none"
												:value="paper.depict"
                    							:actionTitleEditorShow="activeInputId === wid + 'depict'"
												@childValueChange="
													val => {
														paper.depict = val;
													}
												"
											></TitleEditor>
										</div>
									</el-col>
								</el-row>
							</el-row>
							<el-row v-if="!paper.questionsList || !paper.questionsList.length">
								<div
									class="common-border-color"
									style="
										text-align: center;
										height: 300px;
										line-height: 300px;
										border: 1px dashed;
									"
								>
									{{$t('main.clickQuestionTypeAddQuestion')}}
								</div>
							</el-row>
							<QuestionnaireQuesTemplate
								:paper="paper"
								:editIndex="editIndex"
								:editOptionIndex="editOptionIndex"
								:imageUrl="imgUrlData"
								:tipsObj="tipsData"
								@addRows="addRows"
								@addColumn="addColumn"
								@batchAddRows="batchAddRows"
								@batchAddColumns="batchAddColumns"
								@questiondel="questiondel"
								@jumpshow="jumpshow"
								@setEditIndex="setEditIndex"
								@setEditOptionIndex="setEditOptionIndex"
								@deleteOptionColumn="deleteOptionColumn"
								@wjaddquestionoption="wjaddquestionoption"
								@wjdelquestionoption="wjdelquestionoption"
								@wjsetquestionoption="wjsetquestionoption"
								@wjQuestionCopy="wjQuestionCopy"
							></QuestionnaireQuesTemplate>
							
							<EndPageSetting v-if="!isBank" :type="'wj'" :paper="paper"></EndPageSetting>
							<div class="submit-btn" :style="{ width: `${subBtn}` }">
								<el-button :loading="submitLoading" class="submit-exam" type="danger" @click="submit(1)">{{$t('main.CompleteEditing')}}</el-button>
							</div>
						</el-main>
					</el-container>
				</div>
				<!-- 题目设置 -->
				<div
					v-show="(activeQuestion.questionsName || activeQuestion.pageNumber) && isOptionSetting"
					class="wjType  scroll-body"
					:style="{ height: rightheight + 'px' }"
					style="overflow-y: auto; 
						background: #fff;
						padding-bottom: 20px;
						position: fixed;
						right: 18px;"
				>
					<div class="operate_item">
						<el-col :xs="12" :sm="12" :md="12" :lg="12" :xl="12">
							<span class="left" style="font-weight: bold" v-if="activeQuestion.questionsTypeId != 26">Q{{ activeQuestion.quesIndex + 1 }} :{{$t('main.QuestionSetting')}}</span>
							<span v-else class="left" style="font-weight: bold">{{$t('main.pageNumber')}}:{{ activeQuestion.pageNumber }}</span>
						</el-col>
						<el-col :xs="12" :sm="12" :md="12" :lg="12" :xl="12" style="text-align: right"></el-col>
					</div>
					<div class="operate_item" style="font-weight: bold;border-bottom: 1px solid #ccc">
						<el-col :xs="12" :sm="12" :md="12" :lg="12" :xl="12"><span class="left">{{$t('main.WholeQuestionSetting')}}</span></el-col>
					</div>
					<!-- 基础设置 -->
					<div style="width: 90%; margin: 0 auto">
						<!-- 此题必答 -->
						<div v-if="activeQuestion.mustanswer != undefined && activeQuestion.questionsTypeId != 26" class="heiSetting">
							<span class="left">{{$t('main.QuestionMustAnswered')}}</span>
							<span class="right"><el-switch v-model="activeQuestion.mustanswer" :active-value="true" :inactive-value="false"></el-switch></span>
						</div>
						<!-- 问题编码 -->
						<div v-if="activeQuestion.quesCode != undefined" class="heiSetting">
							<span class="left">{{$t('main.ProblemCode')}}</span>
							<span class="right">
								<PopoverText
									ref="quesCodeInput"
									:content="$t('main.ProblemCodeHasBeenUsedAndCannotBeReused')"
									:placeholder="`${$t('main.uniqueIdentification')}：Q1`"
									:value="activeQuestion.quesCode"
									@quesCodeChange="quesCodeChange"
									@setQuesCode="val => (activeQuestion.quesCode = val)"
								></PopoverText>
							</span>
						</div>
						<!-- 最大上传文件数量 -->
						<div v-if="activeQuestion.maxFilesNum != undefined" class="heiSetting">
							<span class="left">{{$t('main.MaximumNumberOfUploadedFiles')}}</span>
							<span class="right" style="width: 85px">
								<el-select v-model="activeQuestion.maxFilesNum" :placeholder="$t('main.PleaseSelect')">
									<el-option v-for="item in numberSel" :key="item.value" :label="item.label" :value="item.value"></el-option>
								</el-select>
							</span>
						</div>
						<!-- 显示样式 -->
						<div v-if="activeQuestion.scoreImg != undefined" class="showStyle">
							<span class="left">{{$t('main.DisplayStyle')}}</span>
							<div class="right">
								<div class="showImg" @click="showRateImg = !showRateImg"><img :src="imgUrlData.imgUrl" alt="" /></div>
								<ul class="showUl" v-show="showRateImg">
									<li v-for="item in rateData" :key="item.id" @click="setShowImg(item.value)"><img :src="item.bgImg" alt="" /></li>
								</ul>
							</div>
						</div>
						<!-- 最低分 -->
						<div v-if="activeQuestion.lowestScore != undefined" class="heiSetting">
							<span class="left">{{$t('main.lowestScore')}}</span>
							<span class="right">
								<el-popover placement="top-end" trigger="manual" :content="$t('main.MinimumScoreMustNotBeGreaterThanOrEqualToTheMaximumScore')" popper-class="error-popover" v-model="lowestScorePopover">
									<el-select slot="reference" v-model="lowestScore" :placeholder="$t('main.PleaseSelect')" size="mini" @change="lowestScoreChange">
										<el-option v-for="(item, index) in 10" :key="item" :label="index" :value="index"></el-option>
									</el-select>
								</el-popover>
							</span>
						</div>
						<!-- 最高分 -->
						<div v-if="activeQuestion.highestScore != undefined" class="heiSetting">
							<span class="left">{{$t('main.highestScore')}}</span>
							<span class="right">
								<el-popover placement="top-end" trigger="manual" :content="$t('main.highestScoreMustNotBeLessThanOrEqualToTheLowestScore')" popper-class="error-popover" v-model="highestScorePopover">
									<el-select slot="reference" v-model="highestScore" :placeholder="$t('main.PleaseSelect')" size="mini" @change="highestScoreChange">
										<el-option v-for="item in 10" :key="item" :label="item" :value="item"></el-option>
									</el-select>
								</el-popover>
							</span>
						</div>
						<!-- 逻辑设置 -->
						<div v-if="activeQuestion.logicalSettings != undefined" class="heiSetting">
							<span class="left">
								{{$t('main.LogicalSettings')}}
								<el-tooltip :content="$t('main.AddLogicalPrompts')" placement="top" effect="light">
									<i class="el-icon-question" style=" color: #ccc"></i>
								</el-tooltip>
							</span>
							<span class="right buttom" style="color: #0080ff"><a @click="toSetLogic">{{$t('main.setUp')}}</a></span>
						</div>

						<div v-if="activeQuestion.isLimitSum != undefined" class="heiSetting-box">
							<div class="switch-box">
								<span>{{$t('main.SumOfRestrictedSpecificGravity')}}</span>
								<span><el-switch v-model="activeQuestion.isLimitSum" :active-value="true" :inactive-value="false"></el-switch></span>
							</div>
							<div v-if="activeQuestion.isLimitSum" >
								<span class="label">{{$t('main.TotalSpecificGravity')}}</span>
								<el-input
									style="width: 178px"
									:maxlength="4"
									v-model.number="activeQuestion.sum"
									@oninput="value = value.replace(/[^0-9.]/g, '')"
									size="mini"
								></el-input>
							</div>
						</div>

						<!-- 提示文字 -->
						<div
							v-if="activeQuestion.leftPromptText != undefined || activeQuestion.centerPromptText != undefined || activeQuestion.rightPromptText != undefined"
							class="tipsTxtBox"
							style="width: 100%; margin: 0 auto"
						>
							<span class="tipsTitle">{{$t('main.PromptText')}}</span>
							<div class="tipsTxt">
								<div class="itemBox">
									<div class="label">{{$t('main.LeftPromptText')}}</div>
									<input class="input" type="text" :maxlength="10" v-model="activeQuestion.leftPromptText" />
								</div>
								<div class="itemBox">
									<div class="label">{{$t('main.IntermediatePromptText')}}</div>
									<input class="input" type="text" :maxlength="10" v-model="activeQuestion.centerPromptText" />
								</div>
								<div class="itemBox">
									<div class="label">{{$t('main.PromptTextOnTheRight')}}</div>
									<input class="input" type="text" :maxlength="10" v-model="activeQuestion.rightPromptText" />
								</div>
							</div>
						</div>
						<!-- 不允许手动修正位置 -->
						<div v-if="activeQuestion.manualCorrectionPosition != undefined" class="heiSetting">
							<span class="left">{{$t('main.ManualPositionCorrectionNotAllowed')}}</span>
							<span class="right"><el-switch v-model="activeQuestion.manualCorrectionPosition" :active-value="true" :inactive-value="false"></el-switch></span>
						</div>
						<!-- 输入框大小 -->
						<div
							v-if="activeQuestion.inputHeight != undefined"
							class="heiSetting"
							style="
								display: block;
							"
						>
							<span class="left">{{$t('main.InputBoxSize')}}</span>
							<div class="right tab_layout input_size w-btn-group">
								<span :class="{ activeCheck: activeQuestion.inputHeight == $t('main.small') }" @click="activeQuestion.inputHeight = $t('main.small')">{{$t('main.small')}}</span>
								<span :class="{ activeCheck: activeQuestion.inputHeight == $t('main.middle') }" @click="activeQuestion.inputHeight = $t('main.middle')">{{$t('main.middle')}}</span>
								<span :class="{ activeCheck: activeQuestion.inputHeight == $t('main.big') }" @click="activeQuestion.inputHeight = $t('main.big')">{{$t('main.big')}}</span>
							</div>
						</div>
						<!-- 单行多行题型切换 -->
						<div v-if="activeQuestion.cutType != undefined && (activeQuestion.questionsTypeId == 3 || activeQuestion.questionsTypeId == 4)" class="heiSetting">
							<span class="left">{{$t('main.QuestionTypeSwitching')}}</span>
							<div class="right tab_layout input_size w-btn-group">
								<span :class="{ activeCheck: activeQuestion.cutType == 1 }" @click="singleInputSwitch">{{$t('main.SingleRow')}}</span>
								<span :class="{ activeCheck: activeQuestion.cutType == 2 }" @click="MultilineInputSwitch">{{$t('main.multipleRows')}}</span>
							</div>
						</div>
						<div
							v-if="
								activeQuestion.cutType != undefined &&
									(activeQuestion.questionsTypeId == 8 || activeQuestion.questionsTypeId == 10 || activeQuestion.questionsTypeId == 6)
							"
							class="heiSetting"
							style="display: block"
						>
							<span class="left">{{$t('main.QuestionType')}}</span>
							<div class="right tab_layout">
								<span :class="{ activeCheck: activeQuestion.cutType == 3 || activeQuestion.cutType == 7 }" @click="radioSwitch">{{$t('main.Radio')}}</span>
								<span :class="{ activeCheck: activeQuestion.cutType == 4 || activeQuestion.cutType == 8 }" @click="multipleChoiceSwitch">{{$t('main.MultipleChoice')}}</span>
							</div>
						</div>
						<div v-if="activeQuestion.cutType != undefined && (activeQuestion.questionsTypeId == 19 || activeQuestion.questionsTypeId == 20)" class="heiSetting" style="display: block">
							<span class="left">{{$t('main.QuestionType')}}</span>
							<div class="right tab_layout">
								<span class="question-type-btn" :class="{ activeCheck: activeQuestion.cutType == 5 }" @click="matrixRadioSwitch">{{$t('main.Radio')}}</span>
								<span class="question-type-btn" :class="{ activeCheck: activeQuestion.cutType == 6 }" @click="matrixMultipleChoiceSwitch">{{$t('main.MultipleChoice')}}</span>
							</div>
						</div>
						<div v-if="activeQuestion.matrixRankRandom != undefined" class="heiSetting">
							<span class="left">{{$t('main.RandomArrangementOfRows')}}</span>
							<span class="right"><el-switch v-model="activeQuestion.matrixRankRandom" :active-value="true" :inactive-value="false"></el-switch></span>
						</div>
						<div v-if="activeQuestion.matrixLineRandom != undefined" class="heiSetting">
							<span class="left">{{$t('main.RandomArrangementOfColumns')}}</span>
							<span class="right"><el-switch v-model="activeQuestion.matrixLineRandom" :active-value="true" :inactive-value="false"></el-switch></span>
						</div>
						<div v-if="activeQuestion.lineRankExchange != undefined" class="heiSetting">
							<span class="left">{{$t('main.MatrixRowColumnExchange')}}</span>
							<span class="right"><el-switch v-model="activeQuestion.lineRankExchange" :active-value="true" :inactive-value="false"></el-switch></span>
						</div>
					</div>
					<!-- 分页设置 -->
					<div v-if="activeQuestion.questionsTypeId == 26">
						<div class="heiSetting" style="width: 90%; margin: 0 auto">
							<span class="left" style="font-weight: bold; font-size: 16px">{{$t('main.PagingSettings')}}</span>
							<span class="right" style="color: #0080ff;cursor: pointer;" @click="applyToAl">{{$t('main.applyToAll')}}</span>
						</div>
						<div class="heiSetting" style="width: 90%; margin: 0 auto">
							<span class="left">{{$t('main.MinimumTime')}}</span>
							<span class="right"><el-switch v-model="activeQuestion.minTimeSwitch" :active-value="true" :inactive-value="false"></el-switch></span>
						</div>
						<div v-if="activeQuestion.minTimeSwitch">
							<div class="heiSetting" style="background: #fafafa">
								<span class="left" style="margin-left: 20px">{{$t('main.MinimumTimeToStayOnThisPage')}}</span>
								<span class="right" style="margin-right: 20px">
									<p>
										<el-input class="short-input" size="mini" v-model="activeQuestion.minTime" :placeholder="$t('main.EnterSeconds')"></el-input>
										{{$t('main.second')}}
									</p>
								</span>
							</div>
						</div>
						<div class="heiSetting" style="width: 90%; margin: 0 auto">
							<span class="left">{{$t('main.MaximumTime')}}</span>
							<span class="right"><el-switch v-model="activeQuestion.maxTimeSwitch" :active-value="true" :inactive-value="false"></el-switch></span>
						</div>
						<div v-if="activeQuestion.maxTimeSwitch">
							<div class="heiSetting" style="background: #fafafa">
								<span class="left" style="margin-left: 20px">{{$t('main.PageNeedsToStayForTheLongestTime')}}</span>
								<span class="right" style="margin-right: 20px">
									<p>
										<el-input class="short-input" size="mini" v-model="activeQuestion.maxTime" :placeholder="$t('main.EnterSeconds')"></el-input>
										{{$t('main.second')}}
									</p>
								</span>
							</div>
						</div>
						<p
							style="
                width: 90%;
                margin: 0 auto;
                height: 60px;
                line-height: 60px;
                border-bottom: 1px solid #ccc;
                font-weight: bold;
              "
						>
						{{$t('main.MoreSettings')}}
						</p>
						<div v-if="activeQuestion.pageNumber > 1" class="heiSetting" style="width: 90%; margin: 0 auto">
							<span class="left">{{$t('main.PreviousButtonText')}}</span>
							<span class="right"><el-input style="width: 120px" size="mini" v-model="activeQuestion.lastBtnText" :placeholder="$t('main.LastPage')"></el-input></span>
						</div>
						<div v-if="pagingArr.length > activeQuestion.pageNumber" class="heiSetting" style="width: 90%; margin: 0 auto">
							<span class="left">{{$t('main.NextPageButtonText')}}</span>
							<span class="right"><el-input style="width: 120px" size="mini" v-model="activeQuestion.nextBtnText" :placeholder="$t('main.NextPage')"></el-input></span>
						</div>
						<div v-if="activeQuestion.pageNumber > 1" class="heiSetting" style="width: 90%; margin: 0 auto">
							<span class="left">{{$t('main.ShowPreviousPagButton')}}</span>
							<span class="right"><el-switch v-model="activeQuestion.lastBtnShow" :active-value="true" :inactive-value="false"></el-switch></span>
						</div>
					</div>
					<!-- 可选范围 -->
					<template v-if="activeQuestion.cutType == 4 || activeQuestion.cutType == 6 || activeQuestion.cutType == 8">
						<div class="operate_item" style="font-weight: bold;border-bottom: 1px solid #ccc">
							<el-col :xs="12" :sm="12" :md="12" :lg="12" :xl="12"><span class="left">{{$t('main.OptionalRange')}}</span></el-col>
						</div>
						<div style="width: 90%; margin: 0 auto">
							<!-- 内容限制 -->

							<div class="heiSetting" style="width: 90%; margin: 0 auto">
								<span>{{$t('main.AtLeast')}}</span>
								<span>
									<el-select style="width: 85px" v-model="activeQuestion.minOptionsNum" @change="upleast" size="mini">
										<el-option :key="0" :label="$t('main.noLimit')" :value="0"></el-option>
										<template v-if="activeQuestion.questionsTypeId == '20'">
											<el-option
												v-for="(item, index) in activeQuestion.questionsSonList[0].optionList"
												:key="index + 1"
												:label="index + 1 + $t('main.term')"
												:value="index + 1"
											></el-option>
										</template>
										<template v-else>
											<el-option v-for="(item, index) in activeQuestion.optionList" :key="index + 1" :label="index + 1 + $t('main.term')" :value="index + 1"></el-option>
										</template>
									</el-select>
								</span>
							</div>

							<div class="heiSetting" style="width: 90%; margin: 0 auto">
								<span>{{$t('main.atMost')}}</span>
								<span>
									<el-select style="width: 85px" v-model="activeQuestion.maxOptionsNum" @change="upmost" size="mini">
										<el-option :key="0" :label="$t('main.noLimit')" :value="0"></el-option>

										<template v-if="activeQuestion.questionsTypeId == '20'">
											<template v-for="(item, index) in activeQuestion.questionsSonList[0].optionList">
												<el-option
													v-if="index + 1 >= activeQuestion.minOptionsNum"
													:key="index + 1"
													:label="index + 1 + $t('main.term')"
													:value="index + 1"
												></el-option>
											</template>
										</template>
										<template v-else>
											<template v-for="(item, index) in activeQuestion.optionList">
												<el-option
													v-if="index + 1 >= activeQuestion.minOptionsNum"
													:key="index + 1"
													:label="index + 1 + $t('main.term')"
													:value="index + 1"
												></el-option>
											</template>
										</template>
									</el-select>
								</span>
							</div>
						</div>
					</template>
					<!-- 填写限制 -->
					<FillInLimit
						v-if="
							activeQuestion.questionsTypeId == 2 || activeQuestion.questionsTypeId == 3 || activeQuestion.questionsTypeId == 4 || activeQuestion.questionsTypeId == 5
						"
						:activeQuestion="activeQuestion"
						:ContentRestrictions="ContentRestrictions"
					/>
					<!-- 选项设置 -->
					<template
						v-if="
							activeQuestion.questionsTypeId == 35 ||
								activeQuestion.questionsTypeId == 6 ||
								activeQuestion.questionsTypeId == 8 ||
								activeQuestion.questionsTypeId == 9 ||
								activeQuestion.questionsTypeId == 10 ||
								activeQuestion.questionsTypeId == 14 ||
								activeQuestion.questionsTypeId == 16 ||
								activeQuestion.questionsTypeId == 37
						"
					>
						<div class="operate_item" style="font-weight: bold;border-bottom: 1px solid #ccc">
							<el-col :xs="12" :sm="12" :md="12" :lg="12" :xl="12"><span class="left">{{$t('main.OptionSettings')}}</span></el-col>
						</div>
						<div v-if="activeQuestion.groupingOptionList != undefined" class="heiSetting" style="width: 90%; margin: 0 auto">
							<span class="left">
								{{$t('main.subset')}}
								<el-tooltip :content="$t('main.OptionGroupingPrompt')" placement="top" effect="light">
									<i class="el-icon-question" style="color: #ccc"></i>
								</el-tooltip>
							</span>
							<span class="right" @click="groupSetting" style="color: #0080ff;cursor: pointer;">{{$t('main.setUp')}}</span>
						</div>
						<div v-if="activeQuestion.choiceRange != undefined" style="width: 90%; margin: 0 auto;font-size: 14px;line-height: 49px;">
							<span>{{$t('main.DetailLevel')}}</span>
							<div v-for="(itemChoice, indexChoice) in cityChoice" :key="indexChoice">
								<el-radio v-model="activeQuestion.choiceRange" :label="itemChoice.value">{{ itemChoice.label }}</el-radio>
							</div>
						</div>
						<div v-if="activeQuestion.optionIfRandom != undefined" class="heiSetting-box" style="width: 90%; margin: 0 auto">
							<div class="switch-box">
								<span>{{$t('main.RandomlyArrangeOptions')}}</span>
								<span><el-switch v-model="activeQuestion.optionIfRandom" :active-value="1" :inactive-value="0"></el-switch></span>
							</div>
							<div class="item-box" v-if="activeQuestion.optionIfRandom == 1">
								<span>{{$t('main.FixTheLastOption')}}</span>
								<span><el-switch v-model="activeQuestion.ifFixedLastOption" :active-value="1" :inactive-value="0"></el-switch></span>
							</div>
						</div>
						<div v-if="activeQuestion.isLimitNum != undefined" class="heiSetting-box" style="width: 90%; margin: 0 auto">
							<div class="switch-box">
								<span>{{$t('main.LimitSpecificGravityMinimumMaximumValue')}}</span>
								<span><el-switch v-model="activeQuestion.isLimitNum" :active-value="true" :inactive-value="false"></el-switch></span>
							</div>
							<div class="item-box" v-if="activeQuestion.isLimitNum">
								<span>{{$t('main.minimumValue')}}</span>
								<el-popover placement="top-end" trigger="manual" :content="$t('main.minimumMustNotBeGreaterThanOrQqualToTheMaximumValue')" popper-class="error-popover" v-model="proportionMinPopover">
									<el-input
										slot="reference"
										v-model.number="proportionMin"
										@blur="proportionMinBlur"
										@oninput="value = value.replace(/[^0-9.]/g, '')"
										size="mini"
									></el-input>
								</el-popover>
							</div>
							<div class="item-box" v-if="activeQuestion.isLimitNum">
								<span>{{$t('main.MaximumValue')}}</span>
								<el-popover placement="top-end" trigger="manual" :content="proportionMaxtext" popper-class="error-popover" v-model="proportionMaxPopover">
									<el-input
										slot="reference"
										v-model.number="proportionMax"
										@blur="proportionMaxBlur"
										@oninput="value = value.replace(/[^0-9.]/g, '')"
										size="mini"
									></el-input>
								</el-popover>
							</div>
						</div>
						<div v-if="activeQuestion.sortsnums != undefined" class="heiSetting" style="width: 90%; margin: 0 auto">
							<span class="left">{{$t('main.OnlySelect')}}</span>
							<div class="right">
								<el-select size="mini" style="width: 85px;" v-model="activeQuestion.sortsnums" :placeholder="$t('main.PleaseSelect')">
									<el-option :label="$t('main.noLimit')" :value="0"></el-option>
									<el-option v-for="(item, index) in activeQuestion.optionList" :key="index + 1" :label="`${index + 1}${$t('main.term')}`" :value="index + 1"></el-option>
								</el-select>
								{{ $t('main.place') }}
							</div>
						</div>
						<div v-if="activeQuestion.showcolnum != undefined" class="heiSetting" style="width: 90%; margin: 0 auto">
							<span class="left">{{ $t('main.OptionLayout') }}</span>
							<div class="right">
								<el-select style="width: 85px" v-model="activeQuestion.showcolnum" size="mini">
									<template v-for="(item, index) in activeQuestion.optionList">
										<el-option :key="index + 1" :label="index + 1 + $t('main.arrange')" :value="index + 1"></el-option>
									</template>
								</el-select>
							</div>
						</div>
						<div v-if="activeQuestion.relation != undefined" class="heiSetting" style="width: 90%; margin: 0 auto">
							<span class="left">{{$t('main.OptionAssociation')}}</span>
							<span class="right" @click="setOptionAssociation" style="color: #0080ff;cursor: pointer;">{{$t('main.setUp')}}</span>
						</div>
					</template>

					<!-- 量表设置 -->
					<ScaleSet v-if="activeQuestion.questionsTypeId == 38" :activeQuestion="activeQuestion"></ScaleSet>
					<!-- 计分设置 -->
					<ScoreOrNotSet v-if="activeQuestion.scoreOrNot != undefined" :activeQuestion="activeQuestion"></ScoreOrNotSet>

					<!-- 选项设置 -->
					<template>
						<div class="operate_item" style="font-weight: bold;border-bottom: 1px solid #ccc">
							<el-col :xs="12" :sm="12" :md="12" :lg="12" :xl="12"><span class="left">{{$t('main.LabelSettings')}}</span></el-col>
						</div>
						<div class="heiSetting" style="width: 90%; margin: 0 auto">
							<span class="left">{{$t('main.tagName')}}</span>
							<span class="right">
								<el-select size="mini" v-model="activeQuestion.quesLabelName" :placeholder="$t('main.PleaseSelect')" multiple collapse-tags>
									<el-option v-for="item in enumByData" :key="item.value" :label="item.value" :value="item.value"></el-option>
								</el-select>
								<!-- <el-input type="text"  size="mini" placeholder="请输入标签名称" v-model="activeQuestion.quesLabelName" maxlength="20" show-word-limit></el-input> -->
							</span>
						</div>
					</template>
				</div>
				<!-- 选项设置 -->
				<div v-if="activeOption.labelName && !isOptionSetting" class="wjType " style="overflow-y: auto; background: #fff;padding-bottom: 20px">
					<div class="operate_item">
						<el-col :xs="12" :sm="12" :md="12" :lg="12" :xl="12">
							<span class="left" style="font-weight: bold">Q{{ activeQuestion.quesIndex + 1 }}:{{ activeOption.labelName }}{{$t('main.SettingsFor')}}</span>
						</el-col>
						<el-col :xs="12" :sm="12" :md="12" :lg="12" :xl="12" style="text-align: right"></el-col>
					</div>
					<!-- 设置内容 -->
					<div>
						<div v-if="activeOption.haveInput != undefined" class="heiSetting" style="width: 90%; margin: 0 auto">
							<span class="left">{{$t('main.AddAFillInBoxAfterTheOption')}}</span>
							<span class="right">
								<el-switch v-model="activeOption.haveInput" :active-value="true" :inactive-value="false" @change="setActiveOption($event, 'haveInput')"></el-switch>
							</span>
						</div>
						<div v-if="activeOption.haveInput == true" style="background: #fafafa">
							<div class="heiSetting" style="display: block;width: 90%; margin: 0 auto">
								<span class="left">{{$t('main.ContentRestrictions')}}</span>
								<span class="right">
									<el-select size="mini" v-model="activeOption.format" :placeholder="$t('main.PleaseSelect')" @change="setActiveOption($event, 'format')">
										<el-option v-for="item in ContentRestrictions" :key="item.value" :label="item.label" :value="item.value"></el-option>
									</el-select>
								</span>
							</div>
							<div class="heiSetting" style="width: 90%; margin: 0 auto">
								<span class="left">
									{{$t('main.WordLimit')}}
									<div v-if="activeOption.haveInput == true" style="display: inline-block; margin-left: 10px">
										<el-input
											size="mini"
											v-model="activeOption.maxNum"
											@change="setActiveOption($event, 'maxNum')"
											type="text"
											style="width: 50px; margin-right: 10px"
										></el-input>
										<span style="">{{$t('main.WithinWords')}}</span>
									</div>
								</span>
								<span class="right">
									<el-switch
										v-model="activeOption.isMaxNum"
										:active-value="true"
										:inactive-value="false"
										@change="setActiveOption($event, 'isMaxNum')"
									></el-switch>
								</span>
							</div>
						</div>
						<template v-if="activeQuestion.questionsTypeId == '22' || activeQuestion.questionsTypeId == '35'">
							<!-- 输入框大小 -->
							<div
								v-if="activeQuestion.questionsTypeId == '35'"
								class="heiSetting"
								style="
									display: block;
									width: 90%; 
									margin: 0 auto
								"
							>
								<span class="left">{{$t('main.InputBoxSize')}}</span>
								<div class="right tab_layout input_size w-btn-group">
									<span :class="{ activeCheck: activeOption.inputHeight == $t('main.small') }" @click="activeOption.inputHeight = $t('main.small')">{{$t('main.small')}}</span>
									<span :class="{ activeCheck: activeOption.inputHeight == $t('main.middle') }" @click="activeOption.inputHeight = $t('main.middle')">{{$t('main.middle')}}</span>
									<span :class="{ activeCheck: activeOption.inputHeight == $t('main.big') }" @click="activeOption.inputHeight = $t('main.big')">{{$t('main.big')}}</span>
								</div>
							</div>
							<div class="heiSetting"  style="display: block;width: 90%; margin: 0 auto"><span class="left">{{$t('main.formatLimits')}}</span></div>
							<div class="heiSetting" style="display: block;width: 90%; margin: 0 auto">
								<span class="left">{{$t('main.FillInAtLeast')}}</span>
								<span class="right"><el-input v-model="activeOption.minNum" @change="setActiveOption($event, 'minNum')"></el-input></span>
							</div>
							<div class="heiSetting" style="display: block;width: 90%; margin: 0 auto">
								<span class="left">{{$t('main.FillInAtMost')}}</span>
								<span class="right"><el-input v-model="activeOption.maxNum" @change="setActiveOption($event, 'maxNum')"></el-input></span>
							</div>
							<div class="heiSetting" style="width: 90%; margin: 0 auto">
								<span class="left">{{$t('main.DefaultText')}}</span>
								<span class="right"><el-input v-model="activeOption.userAnswer" @change="setActiveOption($event, 'userAnswer')"></el-input></span>
							</div>
						</template>
						<div class="heiSetting" style="width: 90%; margin: 0 auto">
							<span class="left">{{$t('main.ThisBlankCanBeLeftBlank')}}</span>
							<span class="right">
								<el-switch v-model="activeOption.notAnswer" :active-value="true" :inactive-value="false" @change="setActiveOption($event, 'notAnswer')"></el-switch>
							</span>
						</div>
					</div>
				</div>
			</div>
		</div>

		<!--题库模态框-->
		<div class="wjType" style="overflow-y: auto; background: #fff">
			<el-dialog :title="`${$t('main.questionBank')}【${curTkType.questionnaireTypeName}】`" :visible.sync="centerDialogVisible" width="30%" center :close-on-click-modal="false">
				<el-table :data="tkList">
					<el-table-column property="questionsName" :label="$t('main.problem')"></el-table-column>
					<el-table-column :label="$t('main.operate')" width="100">
						<template slot-scope="scope">
							<el-button type="text" size="small" @click="addTkItem(scope.row)">{{$t('main.increase')}}</el-button>
						</template>
					</el-table-column>
				</el-table>
				<span slot="footer" class="dialog-footer"><el-button size="medium" @click="centerDialogVisible = false">{{$t('main.cancel2')}}</el-button></span>
			</el-dialog>
		</div>

		<!--填空盒子-->
		<div v-if="hiden" class="mask"></div>
		<div class="details" v-if="hiden">
			<div class="details-1">
				{{$t('main.FillInTheBlankAttribute')}}
				<i class="el-icon-close" @click="close"></i>
			</div>
			<div style="width: 800px; height: 520px; overflow-y: auto">
				<div class="option_content">
					<div v-for="(itemh, indexh) in hengoption" :key="indexh">
						<div v-if="indexh == 0" class="konginput"><el-input v-model="itemh.labelName"></el-input></div>
					</div>
				</div>
				<div class="table_option">
					<div
						style="
              width: 760px;
              height: auto;
              background: #fff;
              margin: 20px auto;
            "
					>
						<table border="1" cellspacing="0" cellpadding="0" style="border: 1px solid #0080ff; border-collapse: collapse">
							<tr>
								<td
									style="
                    width: 100px;
                    text-align: center;
                    height: 48px;
                    font-size: 14px;
                  "
								>
								{{$t('main.FillInTheBlankNumber')}}
								</td>
								<td style="text-align: center">{{$t('main.ContentRestrictions')}}</td>
								<td>{{$t('main.WordRange')}}</td>

								<td>{{$t('main.ThisBlankIsMandatory')}}</td>
							</tr>
							<tr v-for="(itemt, indext) in hengoption" :key="indext">
								<td style="text-align: center; height: 48px">{{ indext + 1 }}</td>
								<td class="selectLength">
									<el-select v-model="itemt.ifLengthLimit" :placeholder="$t('main.PleaseSelect')" @change="Contentheng(itemt.ifLengthLimit, itemt.id, $event)">
										<el-option v-for="item in ContentRestrictions" :key="item.label" :label="item.label" :value="item.value"></el-option>
									</el-select>
								</td>
								<td class="hengInput">
									{{$t('main.HowManyWordsCanIFillInAatMost')}}
									<el-input v-model="itemt.lengthLimit"></el-input>
									{{$t('main.word')}}
								</td>
								<td></td>
							</tr>
						</table>
					</div>
				</div>
			</div>
		</div>

		<div v-if="batchDialog" class="batchPopup">
			<p
				style="
          font-size: 18px;
          color: #333;
          text-align: center;
          margin-top: 24px;
        "
			>
			{{$t('main.BatchAddOptions')}}
			</p>
			<p
				style="
          font-size: 14px;
          color: #333;
          text-align: center;
          margin-top: 11px;
        "
			>
			{{$t('main.MultipleOptionsCanAdded')}}
			</p>
			<textarea
				name=""
				id=""
				cols="30"
				rows="10"
				v-model="addOptions"
				:placeholder="batch_placeholder"
				style="
          border: 1px solid #ccc !important ;
          min-width: 469px;
          min-height: 142px;
          max-width: 469px;
          max-height: 142px;
          margin-left: 36px;
          margin-top: 20px;
        "
			></textarea>
			<p style="width: 100%; margin-left: 168px; margin-top: 10px">
				<el-button size="small" @click="cancelAddOptions()">{{$t('main.cancel')}}</el-button>
				<el-button size="small" type="primary" @click="saveAddOptions(addOptions)">{{$t('main.save')}}</el-button>
			</p>
		</div>

		<el-dialog :title="$t('main.EditTitle')" :visible.sync="titledialogVisible" :modal-append-to-body="false" :z-index="200" width="50%">
			<div style="padding: 20px;"><MyCKEditor v-if="titledialogVisible" :id="edittitle" v-model="paper.title" @blur="wjedit()" /></div>
		</el-dialog>

		<!-- 显示跳转逻辑弹窗 -->
		<LogicSettings ref="logicSettings" :paper="paper" :activeQuestion="activeQuestion"></LogicSettings>

		<!-- 选项关联 -->
		<el-dialog class="option-association" :title="$t('main.OptionAssociation')" :visible.sync="AssociationShow" :close-on-click-modal="false" :close-on-press-escape="false" width="40%">
			<el-form ref="optionAssociation" label-width="70px" class="demo-dynamic" style="margin-top: 13px; max-height: 400px; overflow: auto">
				<el-form-item v-for="(item, index) in questionRelationList" :key="index">
					<div class="choiceQuestion" style="float: left">
						<span style="margin-right: 10px">{{$t('main.SetTheQuestion')}}</span>
						<el-select v-model="item.id" :placeholder="$t('main.PleaseSelectAnOption')" value-key="id" @change="relationChange" @visible-change="relationVisibleChange">
							<template v-for="info in optionAssociationList">
								<el-option :key="info.qid" :label="$functions.htmlFormat(info.questionsName)" :value="info.qid"></el-option>
							</template>
						</el-select>
						<span style="margin-left: 10px">{{$t('main.SelectedItemsAsOptionsForThisQuestion')}}</span>
					</div>
					<div class="icon_num">
						<i style="cursor: pointer;" class="icon iconfont iconjian" @click="removeAssociation(item)"></i>
						<i style="cursor: pointer;" class="icon iconfont iconjia" @click="addAssociation(index)"></i>
					</div>
				</el-form-item>
			</el-form>
			<span slot="footer" class="dialog-footer">
				<el-button size="small" @click="AssociationShow = false">{{$t('main.cancel2')}}</el-button>
				<el-button size="small" type="primary" @click="saveAssociation">{{$t('main.ok2')}}</el-button>
			</span>
		</el-dialog>
		<el-dialog :title="$t('main.tip')" :visible.sync="dialogVisibleSubmit" width="30%" :close-on-click-modal="false">
			<span>{{$t('main.FinishedEditing')}}</span>
			<div slot="footer" class="dialog-footer">
				<el-button @click="dialogVisibleSubmit = false" size="small">{{$t('main.continueEditing')}}</el-button>
				<el-button type="primary" @click="toReleaseExam" size="small" icon="el-icon-position">{{$t('main.PublishNow')}}</el-button>
			</div>
		</el-dialog>

		<input type="file" style="display: none" id="uploadFile" @change="uploadFile" />
	</div>
</template>

<script>
import Paper from './js/Paper.js';
import { mapActions, mapState, mapMutations } from 'vuex';
import { getQuesType } from './js/getQuesType.js';
import QuestionnaireQuesTemplate from './components/testPaperDesign/index';
import { v1 as UUID } from 'uuid';
import TitleEditor from '@/components/titleEditor/titleEditor.vue';
import QuestionTypeList from '@/components/examQuesTemplate/questionTypeList.vue';
import QuestionBankList from '@/components/examQuesTemplate/questionBankList.vue';
import ScaleSet from './components/propertySetting/scaleSet.vue';
import ScoreOrNotSet from './components/propertySetting/scoreOrNotSet.vue';
import FillInLimit from './components/propertySetting/fillInLimit.vue';

import LogicSettings from './components/propertySetting/logicSettings.vue';
import PopoverText from '@/components/myComponents/popoverText.vue';
import QuestionOutline from '@/components/examQuesTemplate/questionOutline.vue';
import EndPageSetting from '@/components/endPageSetting/endPageSetting.vue';

// 修改---

import MyCKEditor from '@/components/ckedit/index';

import AES from '@/util/AES.js';
import CheckType from '@/util/JSON/checkType.json';
export default {
	inject: ['reload'],
	name: 'QuestionType',
	components: {
		QuestionnaireQuesTemplate,
		MyCKEditor,
		TitleEditor,
		// QuestionTypeList,
		// QuestionBankList,
		ScaleSet,
		ScoreOrNotSet,
		LogicSettings,
		PopoverText,
		// QuestionOutline,
		EndPageSetting,
		FillInLimit
	},
	props: {
		isTemplate: {
			type: Boolean,
			default: false
		},
		isBank: {
			type: Boolean,
			default: false
		},
		paperObj: {
			type: Object,
			default: () => {
				return {};
			}
		}
	},
	provide() {
		return {
			isBank: this.isBank
		};
	},
	data() {
		return {
			searchQuestionsList: [],
			queryOutline: '',
			loading: true,
			paperReturnSuccess: false,
			enumByData: [],
			wid: '',
			paper: {},
			activeQuestion: {},
			activeOption: {},

			edittitle: 'edittitle',
			editcontent: 'editcontent',
			titledialogVisible: false,
			showTitleEdit: false,
			editCurQuestionList: 0,
			setIfFillEmptyOptions: 0,
			pagingArr: [], //分页数组
			scoreImg: '',
			showRateImg: false,
			imgUrl: require('@/assets/rate/stars.png'),
			tipsData: {
				left: '',
				center: '',
				right: ''
			},
			imgUrlData: {
				imgUrl: require('@/assets/rate/stars.png'),
				checkedImg: require('@/assets/rate/star_def.png'),
				unCheckedImg: require('@/assets/rate/star_sel.png'),
				value: 'star'
			},
			rateData: [
				{
					bgImg: require('@/assets/rate/stars.png'),
					checkedImg: require('@/assets/rate/star_def.png'),
					unCheckedImg: require('@/assets/rate/star_sel.png'),
					value: 'star'
				},
				{
					bgImg: require('@/assets/rate/heart.png'),
					checkedImg: require('@/assets/rate/heart_def.png'),
					unCheckedImg: require('@/assets/rate/heart_sel.png'),
					value: 'heart'
				},
				{
					bgImg: require('@/assets/rate/smile.png'),
					checkedImg: require('@/assets/rate/laugh_def.png'),
					unCheckedImg: require('@/assets/rate/laugh_sel.png'),
					value: 'smile'
				},
				{
					bgImg: require('@/assets/rate/good.png'),
					checkedImg: require('@/assets/rate/good_def.png'),
					unCheckedImg: require('@/assets/rate/good_sel.png'),
					value: 'thumb'
				}
			],
			columnWidthUnit: [
				{
					value: 'px',
					label: 'px'
				},
				{
					value: '%',
					label: this.$t('main.percentage')
				}
			],
			RectifRow: '', //是否是矩阵行还是矩阵列
			rectvalue: false, // 矩阵题颜色是否必填
			questionID: '', //矩阵题ID
			jz: '', //判断是否为矩阵题
			set: '',
			tkList: [],
			curTkType: {},
			centerDialogVisible: false,
			selectTypeIndex: 0,
			arrhref: 1,
			wjTypeList: [], //题库组件 ↑
			selectIndexicon: -1,
			optionAssociationList: [],
			addOptions: [],
			batch_placeholder: '',
			queryRelationLogics: [], // 查询关联以后题目数据
			questionContent: '', // 问卷描述
			questionWjTitle: '', // 问卷标题
			questionsName: '', // 问卷题目名称
			questionOptionList: [], // 临时存放当前选中题目的选项
			questionsSonOptionList: [], // 临时存放当前选中题目的子题目选项
			sonQuestionslist: [], // 临时存放子题目数组
			batchDialog: false,
			isOptionSetting: true, // 右侧设置 题目与选项切换
			showButton: '',
			bbutton: '',
			ubutton: '',
			most: '',
			checkedGroup: '',
			groupSearch: '',
			grouping: false, //选项分组模态框
			dynamic: {
				domians: [
					{
						title: '',
						condSelect: '',
						selectOpt: '',
						questionsTypeId: '', // 问卷题目类型
						showLogicCondition: [
							{
								label: this.$t('main.Selected'),
								value: 1
							},
							{
								label: this.$t('main.notSelected'),
								value: 2
							},
							{
								label: this.$t('main.show'),
								value: 3
							},
							{
								label: this.$t('main.NoShow'),
								value: 4
							}
						],
						options: []
					}
				]
			},

			dynamicValidateForm: {
				domains: [
					{
						selectOption: '',
						quesTitle: ''
					}
				]
			},
			// qtypeval:'题目控件',
			// qtypes:['题目控件','我的题库'],
			typeObj: [],
			// selectIndex: 0,
			curWjInfo: {},
			height: '',
			isCollapse: true,
			rightheight: 0,
			left: 0,
			top: 0,
			editIndex: -1,
			editOptionIndex: '0_0',
			currentSort: 0,
			content: [
				{
					ContentRes: ''
				},
				{
					lineInput: ''
				},
				{
					gapFil: ''
				},
				{
					multiline: ''
				}
			],
			theHighestScore: [
				{
					label: '1',
					value: 0
				},
				{
					label: '2',
					value: 1
				},
				{
					label: '3',
					value: 2
				},
				{
					label: '4',
					value: 3
				},
				{
					label: '5',
					value: 4
				},
				{
					label: '6',
					value: 5
				},
				{
					label: '7',
					value: 6
				},
				{
					label: '8',
					value: 7
				},
				{
					label: '9',
					value: 8
				},
				{
					label: '10',
					value: 9
				}
			],
			minimumRange: [{ value: 0, label: this.$t('main.noLimit') }, { value: 1, label: this.$t('main.Item1') }, { value: 2, label: this.$t('main.Item2') }], //最少范围
			maximumRange: [{ value: 0, label: this.$t('main.noLimit') }, { value: 1, label: this.$t('main.Item1') }, { value: 2, label: this.$t('main.Item2') }], //最大范围
			inputBoxSize: '',
			ifMustAnswer: '',
			startnum: 1,
			endnum: 500,
			inputLeast: '',
			inputMoster: '',
			questionsTypeId: '',
			value1: null,
			optionIfRandom: '',
			ifFixedLastOption: '',
			switchID: '',
			betweenGroupRandom: '',
			inGroupRandom: '',
			manualSetting: '',
			matrixLineRandom: '',
			matrixRankRandom: '',
			lineRankExchange: '',
			questionsType: '',
			questionLayout: '',
			questionlineRank: '',
			choice: [
				{
					leftChoice: ''
				},
				{
					rightChoice: ''
				},
				{
					sortsnums: ''
				}
			],
			choiceContent: [
				{
					label: this.$t('main.noLimit'),
					value: 0
				},
				{
					label: this.$t('main.Item1'),
					value: 1
				},
				{
					label: this.$t('main.Item2'),
					value: 2
				}
			],

			cityChoice: [
				{
					label: this.$t('main.DetailedToDetailedAddress'),
					value: 4
				},
				{
					label: this.$t('main.DetailedToCity'),
					value: 3
				},
				{
					label: this.$t('main.DetailedToCity'),
					value: 2
				},
				{
					label: this.$t('main.DetailedTopProvince'),
					value: 1
				}
			],

			choiceRange: 0,
			hiden: false,
			hengoption: {},
			hengSelect: '',
			numberSel: [
				{
					value: 1,
					label: 1
				},
				{
					value: 2,
					label: 2
				},
				{
					value: 3,
					label: 3
				},
				{
					value: 4,
					label: 4
				},
				{
					value: 5,
					label: 5
				}
			],
			jumpLogicQuerys: [],
			jumpSwitch: '',
			itemIndex: 0,
			itemInId: '',
			optionDemos: [],
			relationQuestionsId: '',
			questionRelationList: [],
			groupQuery: [], //有多少分组
			optionGroup: [], // 可以设置分组的选项有多少
			checkList: [],
			optionGrouping: [],
			checkedCities: [], //右侧的分组
			ifGrouping: '',
			least: '',
			optionmyEmit: {}, //当前在设置的选项
			AssociationShow: false,
			outerLayer: -1,
			selectId: '',
			detailedAddressIndexXF: 0,
			drag: false,
			drag_model: [],
			subBtn: '',
			operationTimer: '',
			countDown: 60,
			dialogVisibleSubmit: false,
			createTime: '',
			citableQuesList: [],
			groupSearchList: [],
			activeTabsName: 'first',
			bankList: [],
			jumpQuesOptionList: [],
			proportionMin: 0,
			proportionMax: 100,
			proportionMinPopover: false,
			proportionMaxPopover: false,
			proportionMaxtext: this.$t('main.maximumValueMustNotBeLessThanOrEqualToTheMinimumValue'),
			activeQuesIndex: -1, // 当前大纲选中的试题index 包含所有题型
			questionCopy: {}, // 复制到的试题
			submitLoading: false,
			lowestScore: 1,
			highestScore: 5,
			lowestScorePopover: false,
			highestScorePopover: false
		};
	},
	computed: {
		...mapState(['wjQuestionTypeArr', 'activeInputId']),
		question_number() {
			let map = {};
			this.paper.questionsList
				.filter(item => item.questionsTypeId != 26)
				.forEach((item, index) => {
					map[item.id] = index + 1;
				});
			return map;
		},
		//选项验证类型
		ContentRestrictions () {
			return CheckType
		}
	},
	created() {
		if (sessionStorage.getItem('examId')) {
			sessionStorage.removeItem('examId');
		}
		// 创建paper
		this.initFunction();
		this.getBankList();
	},
	mounted() {
		// 获取创建时间
		this.createTime = this.$functions.GetDate();
		this.arrhref = this.$route.query.typeId;
		this.loadWjTypes();
		this.loadAskTypeData();
		var winHeight = document.body.clientHeight || document.documentElement.clientHeight;

		this.height = winHeight - 108;
		this.rightheight = winHeight - 60 - 64;
		window.onresize = () => {
			var winHeight = document.body.clientHeight || document.documentElement.clientHeight;
			this.height = winHeight - 108;
			this.rightheight = winHeight - 60 - 64;
		};

		this.wid = sessionStorage.getItem('wid') || 0;
		this.queryEnumByType();
		if (this.isBank) {
			this.loading = false;
			this.paper = this.paperObj;
			return;
		}
		if (this.wid == 0) {
			this.wjadd();
		} else {
			sessionStorage.setItem('wid', this.wid);
			this.loadQuestionList();
		}
	},
	watch: {
		// 获取路由
		$route() {
			let arrhref = this.$route.query.typeId;
			this.arrhref = arrhref;
		},

		// 12.3设置字数
		startnum(oldval, newval) {
			//  console.log("oldval", oldval, "=====", "newval", newval);
			if (this.startnum <= 0) {
				this.startnum = 0;
			}
			let that = this;
			let params = {
				that: this,
				url: `${this.$config.service.setupleast}`,
				method: 'POST',
				data: {
					id: that.switchID,
					least: oldval
				},
				cb(res) {
					if (res.code == 0) {
						// console.log("输出", res);
					}
				}
			};
			this.$util.request(params);
		},
		endnum(oldval, newval) {
			// console.log("oldval", oldval, "====", "newval", newval);
			let that = this;
			let params = {
				that: this,
				url: `${this.$config.service.setupmost}`,
				method: 'POST',
				data: {
					id: that.switchID,
					most: oldval
				},
				cb(res) {
					if (res.code == 0) {
						//   console.log("输出", res);
					}
				}
			};
			this.$util.request(params);
		},
		'paper.questionsList': {
			handler(vnew, vold) {
				let quesCount = 0;
				let pageCount = 0;
				if (this.paper.questionsList.length > 0) {
					this.pagingArr = [];
					this.paper.questionsList.forEach(info => {
						if (info.questionsTypeId == '26') {
							this.pagingArr.push(info);
							pageCount++;
						} else if (info.questionsTypeId == '25') {
							info.quesIndex = null;
						}
						if (this.wjQuestionTypeArr.indexOf(info.questionsTypeId) != -1) {
							quesCount++;
						}
						if (info.isedit == true) {
							this.activeQuestion = info;
							if (this.activeQuestion.questionsTypeId == 37) {
								this.proportionMin = this.activeQuestion.minNum;
								this.proportionMax = this.activeQuestion.maxNum;
							} else if (this.activeQuestion.questionsTypeId == 11) {
								this.highestScore = this.activeQuestion.highestScore;
								this.lowestScore = this.activeQuestion.lowestScore;
							}
							this.toSetAppoint();
						}
					});
					this.changeSort();
					this.paper.pageCount = pageCount;
					this.paper.quesCount = quesCount;
				}
			},
			deep: true
		},
		paper: {
			handler(vnew, vold) {
				// console.log('更新了')
				clearTimeout(this.operationTimer);
				this.timer();
				this.countDown = 60;
			},
			deep: true
		},
		activeTabsName(newval, oldval) {
			this.queryOutline = '';
			this.searchQuestionsList = JSON.parse(JSON.stringify(this.paper.questionsList));
		}
	},

	methods: {
		...mapActions(['setActiveInput']),
		...mapMutations(['setCitableQuesList', 'removeCitableQuesList', 'removeHtmlEditor']),
		queryQuestionOutline() {
			this.searchQuestionsList = JSON.parse(JSON.stringify(this.paper.questionsList));
			console.log('queryOutline', this.searchQuestionsList);
			// console.log(this.paper.questionsList);
			// console.log(this.filterList());
			if (this.queryOutline == '') {
				this.searchQuestionsList = this.paper.questionsList;
			} else {
				this.searchQuestionsList = this.filterList();
			}
		},
		filterList() {
			return this.searchQuestionsList.filter(p => {
				return p.questionsName.indexOf(this.queryOutline) !== -1;
			});
		},
		htmlToString(htmlStr) {
			return htmlStr.replace(/<\/?.+?\/?>|\r|\n*/g, '');
		},
		// 矩阵题 所有选项名称 以第一项选项名称为准
		setMatrixOption() {
			this.paper.questionsList = this.paper.questionsList.map(info => {
				if (info.questionsTypeId == '19' || info.questionsTypeId == '20' || info.questionsTypeId == '21' || info.questionsTypeId == '22') {
					info.questionsSonList = info.questionsSonList.map(son => {
						son.optionList = son.optionList.map((op, index) => {
							// 	console.log(op.labelName, info.questionsSonList[0].optionList[index].labelName)
							op.labelName = info.questionsSonList[0].optionList[index].labelName;
							op.oid = info.questionsSonList[0].optionList[index].oid;
							// console.log(op.labelName)
							return op;
						});
						// console.log(son.optionList)

						return son;
					});
				}
				return info;
			});
		},
		// 锚点定位
		goAnchor(aname, qid, index) {
			this.$nextTick(() => {
				let selector = `div[name=${aname}]`;
				var anchor = this.$el.querySelector(selector);
				if (anchor) {
					anchor.scrollIntoView({ block: 'center', behavior: 'smooth' });
				}
			});
			this.activeQuesIndex = this.paper.questionsList.findIndex(info => info.qid == qid);
			if (index == 0) {
				this.setEditIndex(this.activeQuesIndex);
			}
		},
		wjQuestionCopy(question) {
			this.paper.cancleEdit();
			this.paper.copyQuestion(question, question.quesIndex);
		},
		// 复制 将当前试题复制到模板
		copyClick() {
			this.questionCopy = this.paper.questionsList[this.activeQuesIndex];
			if (this.questionCopy?.qid) {
				this.$message({
					message: this.$t('main.ReplicatingSuccess'),
					type: 'success'
				});
				console.log(this.questionCopy);
			} else {
				this.$message({
					message: this.$t('main.PleaseSelectTheTestQuestionFirst'),
					type: 'warning'
				});
			}
		},
		// 粘贴试题
		pasteClick() {
			if (this.questionCopy && this.questionCopy.qid) {
				this.paper.cancleEdit();
				this.paper.copyQuestion(this.questionCopy, this.activeQuesIndex);
				if (this.questionCopy?.qid) {
					this.$message({
						message: this.$t('main.ReplicatingSuccess'),
						type: 'success'
					});
				} else {
					this.$message({
						message: this.$t('main.ThereAreCurrentlyNoTestQuestionsToPaste'),
						type: 'warning'
					});
				}
			} else {
					this.$message({
						message: this.$t('main.ThereAreCurrentlyNoTestQuestionsToPaste'),
						type: 'warning'
					});
				}
		},
		// 批量添加试题
		batchAddQues(list) {
			let newArr = [...this.paper.questionsList, ...list];
			this.paper.questionsList = newArr
		},
		queryEnumByType() {
			let that = this;
			let params = {
				that: this,
				url: `${this.$config.service.queryEnumByType}`,
				method: 'POST',
				data: {
					qid: that.wid,
					type: 'bq',
					pageSize: 10000,
					currentPage: 1
				},
				cb(res) {
					// console.log(res);
					if (res.code == '0') {
						that.enumByData = res.resultBody.records;
					} else {
						that.enumByData = [];
						that.$message.error(res.message);
					}
				}
			};
			this.$util.request(params);
		},
		// 上传文件
		uploadFile(data) {
			var objFile = document.getElementById('uploadFile');
			// var objFile = data.target
			if (objFile.value == '') {
				alert(this.$t('main.CannotBeEmpty'));
			}

			var files = objFile.files; // 获取到文件列表
			if (files.length == 0) {
				alert(this.$t('main.PleaseSelectAFile'));
			} else {
				// var reader = new FileReader() //新建一个FileReader
				var reader = new FileReader();
				// reader.readAsDataURL(files);
				reader.readAsText(files[0], 'UTF-8'); // 读取文件
				var self = this;
				reader.onload = function(e) {
					// 读取完文件之后会回来这里
					var fileString = e.target.result; // 读取文件内容
					var srt = AES.decrypt(fileString);
					self.paper = new Paper();
					console.log(self.paper);
					console.log(JSON.parse(srt));
					self.paper.depict = JSON.parse(srt).depict;
					self.paper.endPageAdvanceMsg = JSON.parse(srt).endPageAdvanceMsg;
					self.paper.endPageNormalMsg = JSON.parse(srt).endPageNormalMsg;
					self.paper.endPageType = JSON.parse(srt).endPageType;
					self.paper.pageCount = JSON.parse(srt).pageCount;
					self.paper.quesAtive = JSON.parse(srt).quesAtive;
					self.paper.quesCount = JSON.parse(srt).quesCount;
					let questionsList = JSON.parse(srt).questionsList;
					questionsList.forEach(item => {
						item.qid = UUID();
					});
					self.paper.questionsList = questionsList;
					self.paper.title = JSON.parse(srt).title;
				};
				reader.onerror = function(e) {
					alert(self.$t('main.fileReadFailure'));
				};
				// reader.readAsBinaryString(f)
			}
		},
		// 导入数据
		importData() {
			let element = document.getElementById('uploadFile');
			element.click();
		},
		exportData() {
			// console.log(this.paper);
			var keys = AES.generatekey(16);
			let data = this.paper;
			// 加密
			var encrypts = AES.encrypt(JSON.stringify(data));
			// 解密
			// var dess = AES.decrypt(encrypts)
			let jsonObj = encrypts;
			// 创建a标签
			var elementA = document.createElement('a');
			// 文件的名称为时间戳加文件名后缀
			let title = JSON.parse(JSON.stringify(this.paper.title));
			elementA.download = this.htmlToString(title) + `_${this.$t('main.questionnaire')}.txt`;
			elementA.style.display = 'none';
			// 生成一个blob二进制数据，内容为json数据
			var blob = new Blob([encrypts]);
			// 生成一个指向blob的URL地址，并赋值给a标签的href属性
			elementA.href = URL.createObjectURL(blob);
			document.body.appendChild(elementA);
			elementA.click();
			document.body.removeChild(elementA);
		},
		// 比重题最大值
		proportionMaxBlur(e) {
			if (this.activeQuestion.isLimitSum && this.proportionMax > this.activeQuestion.sum) {
				this.proportionMaxtext = this.$t('main.maximumValueMustNotExceedTheTotalSpecificGravity');
				this.proportionMaxPopover = true;
				this.proportionMax = this.activeQuestion.maxNum;
				setTimeout(() => {
					this.proportionMaxPopover = false;
				}, 2000);
				return;
			}

			if (this.proportionMin > this.proportionMax || this.proportionMin == this.proportionMax) {
				this.proportionMaxtext = this.$t('main.maximumValueMustNotBeLessThanOrEqualToTheMinimumValue');
				this.proportionMaxPopover = true;
				this.proportionMax = this.activeQuestion.maxNum;
				setTimeout(() => {
					this.proportionMaxPopover = false;
				}, 2000);
			} else {
				this.activeQuestion.maxNum = this.proportionMax;
			}
		},
		// 最小值不得大于或小于最大值
		proportionMinBlur() {
			if (this.proportionMin > this.proportionMax || this.proportionMin == this.proportionMax) {
				this.proportionMinPopover = true;
				this.proportionMin = this.activeQuestion.minNum;
				setTimeout(() => {
					this.proportionMinPopover = false;
				}, 2000);
			} else {
				this.activeQuestion.minNum = this.proportionMin;
			}
		},
		// 最低分不得大于或小于最高分
		lowestScoreChange() {
			if (this.lowestScore > this.highestScore || this.lowestScore == this.highestScore) {
				this.lowestScorePopover = true;
				this.lowestScore = this.activeQuestion.lowestScore;
				setTimeout(() => {
					this.lowestScorePopover = false;
				}, 2000);
			} else {
				this.activeQuestion.lowestScore = this.lowestScore;
			}
		},
		// 最高分不得小于或大于最低分
		highestScoreChange() {
			if (this.lowestScore > this.highestScore || this.lowestScore == this.highestScore) {
				this.highestScorePopover = true;
				this.highestScore = this.activeQuestion.highestScore;
				setTimeout(() => {
					this.highestScorePopover = false;
				}, 2000);
			} else {
				this.activeQuestion.highestScore = this.highestScore;
			}
		},
		// 题库start
		addBank(e, qid) {
			let that = this;
			let params = {
				that: this,
				url: `${this.$config.service.examBankSave}`,
				method: 'POST',
				data: e,
				cb(res) {
					// console.log(res);
					if (res.code == '0') {
						let paper = new Paper();
						that.setPaperJson(res.message, paper, qid);
					} else {
						that.$message.error(res.message);
					}
				}
			};
			this.$util.request(params);
		},

		setPaperJson(id, paper, qid) {
			let that = this;
			let data = {
				id: id,
				paperjson: JSON.stringify(paper),
				bankType: 1
			};
			let params = {
				that: this,
				url: `${this.$config.service.examBankAddQuess}`,
				method: 'post',
				data: data,
				cb(res) {
					if (res.code == '0') {
						that.getBankList();
						// console.log(that.$refs.quesTemplate1)
						let ref = `ques${qid}`;
						// console.log(that.$refs[ref][0]);
						that.$refs[ref][0].cancelAddBank();
					} else {
						that.$message.error(res.message);
					}
				}
			};
			this.$util.request(params);
		},
		getBankList() {
			let that = this;
			let data = this.$qs.stringify({
				isSystem: 0, // 0自建题库 1系统题库
				pageIndex: 1,
				pageSize: 10000,
				bankType: 1
			});
			let params = {
				that: this,
				url: `${this.$config.service.examBankList}?${data}`,
				method: 'GET',
				cb(res) {
					// console.log(res);
					if (res.code == '0') {
						that.bankList = res.resultBody.datas;
					} else {
						that.bankList = [];
					}
				}
			};
			this.$util.request(params);
		},

		// 引用题库试题
		quesFormBand(item) {
			this.paper.cancleEdit();
			let e = {...item, bid: '', bqid: ''}
			e.isedit = true;
			// e.bqid = e.qid;
			e.qid = UUID();
			// console.log(e);
			let index = -1;
			this.paper.questionsList.forEach((info, i) => {
				if (this.paper.quesAtive && info.qid == this.paper.quesAtive) {
					index = i;
				} else if (!this.paper.quesAtive) {
					this.paper.quesAtive = e.qid
					this.paper.questionsList.push(e);
				}
			});
			if (index != -1) {
				this.paper.questionsList.splice(index + 1, 0, e);
			}
			if (this.paper.questionsList.length == 0) {
				this.paper.questionsList.push(e);
			}
		},
		// 题库end

		toSetAppoint() {
			this.citableQuesList = [];
			let quesTypeArr = ['6', '8', '9', '10', '12', '2', '3', '4', '5'];
			let index = 0;
			for (let i = 0; i < this.paper.questionsList.length; i++) {
				if (this.activeQuestion.qid == this.paper.questionsList[i].qid) {
					index = i;
				}
			}
			this.paper.questionsList.forEach((info, j) => {
				if (j < index && quesTypeArr.indexOf(info.questionsTypeId) !== -1) {
					// info.questionsName = info.questionsName.replace(/<img[^>]*>/g, '[图片]').replaceAll(/<[^>]+>/g,'')
					this.citableQuesList.push(info);
				}
			});
			this.$store.commit('setCitableQuesList', this.citableQuesList);
		},
		// 逻辑设置start

		// 逻辑设置弹窗
		jumpshow() {
			this.toSetLogic();
		},
		// 打开逻辑设置弹窗
		toSetLogic() {
			this.$refs.logicSettings.toSetLogic();
		},
		timer() {
			this.operationTimer = setTimeout(() => {
				// console.log(this.countDown)
				if (this.countDown > 0) {
					this.countDown--;
					this.timer();
				} else {
					let wid = sessionStorage.getItem('wid');
					if (this.paperReturnSuccess && wid) {
						this.submit();
					}
				}
			}, 1000);
		},

		toReleaseExam() {
			this.dialogVisibleSubmit = false;
			this.$router.push({ path: '/wjmanage/wjpub' });
		},
		submit(state) {
			if (state) {
				this.submitLoading = true;
			}
			// 判断图片选择题 上传图片
			let imgExist = false;
			if (state == 1) {
				if (this.paper.questionsList.length > 0) {
					this.paper.questionsList.forEach(item => {
						if (item.questionsTypeId == 6) {
							if (item.optionList.length == 0) {
								this.$message.warning(this.$t('main.ImageUploadQuestionDidNotUploadImages'));
								imgExist = true;
							}
						}
					});
				}
			}
			if (imgExist) {
				this.submitLoading = false;
				return false;
			}

			let that = this;
			clearTimeout(this.operationTimer);

			// setMatrixOption在提交时统一选项的oid与name,为了兼容已创建的矩阵题，后续可以删掉 22/12/28
			this.setMatrixOption();

			let paperJson = JSON.parse(JSON.stringify(this.paper));
			if(paperJson.questionsListCopy){
				paperJson.questionsListCopy.forEach(item=>{
					console.log(item,'copy11111111111')
					paperJson.questionsList.forEach(item2=>{
						console.log(item2,'questionsList')
						if(item2.qid==item.qid){
							console.log(item2,item)
							item = item2
						}
					})
				})
				paperJson.questionsList =paperJson.questionsListCopy
				delete paperJson.questionsListCopy
			}
			let data = {
				id: this.wid,
				paperjson: JSON.stringify(paperJson),
				createTime: this.createTime,
				updateTime: this.$functions.GetDate()
			};
			console.log('data',this.isTemplate)
			console.log('data',this.isBank)
			// return false
			if (this.isBank) {
				this.$emit('submit', state);
				return;
			}
			if (this.isTemplate) {
				this.isTemplateSubmiit(data);
			} else {
				this.isprojectSubmiit(data, state);
			}
		},
		isprojectSubmiit(data, state) {
			let that = this;
			let params = {
				that: this,
				url: `${this.$config.service.addQuestionnaire}`,
				method: 'post',
				data: data,
				cb(res) {
					that.submitLoading = false;
					// console.log(res);
					if (res.code == '0') {
						// console.log('保存成功');

						if (state == 1) {
							that.dialogVisibleSubmit = true;
						}
					} else {
						that.$message.error(res.message);
					}
				}
			};
			this.$util.request(params);
		},
		isTemplateSubmiit(data) {
			let that = this;
			let params = {
				that: this,
				url: `${this.$config.service.addTemp}`,
				method: 'post',
				data: data,
				cb(res) {
					that.submitLoading = false;
					// console.log(res);
					if (res.code == '0') {
						// console.log('保存成功');
						that.$emit('closeQuestionstype', false);
					} else {
						that.$message.error(res.message);
					}
				}
			};
			this.$util.request(params);
		},
		handleResize({ width, height }) {
			this.subBtn = width;
			// console.log('handleResize', width, height);
		},
		// 题型添加问题
		selectTypeQuestion(item) {
			// console.log('添加试题');
			//取消正在编辑的问题
			this.paper.cancleEdit();
			//新插入的问题设置为编辑状态
			// this.editIndex = editIndex
			let type = getQuesType(item.type)
			this.paper.createQuestion(type);
		},
		// 题目重新排序
		changeSort() {
			// console.log(this.paper.questionsList)
			let pageNumber = 1;
			let quesIndex = 0;
			this.paper.questionsList.forEach((info, index) => {
				// console.log(info.questionsTypeId)
				if (info.questionsTypeId == '26') {
					info.pageNumber = pageNumber++;
				} else if (this.wjQuestionTypeArr.indexOf(info.questionsTypeId) != -1) {
					info.quesIndex = quesIndex++;
				}
			});
		},
		//默认创建对象
		initFunction() {
			this.paper = new Paper();
		},
		singleInputSwitch() {
			// console.log(this.activeQuestion)
			this.activeQuestion.cutType = 1;
			this.activeQuestion.questionsTypeId = '3';
		},
		MultilineInputSwitch() {
			this.activeQuestion.cutType = 2;
			this.activeQuestion.questionsTypeId = '4';
		},
		radioSwitch() {
			if (this.activeQuestion.cutType == 4) {
				this.activeQuestion.cutType = 3;
				this.activeQuestion.questionsTypeId = '8';
			} else if (this.activeQuestion.cutType == 8) {
				this.activeQuestion.cutType = 7;
			}
			// console.log(this.activeQuestion);
		},
		multipleChoiceSwitch() {
			if (this.activeQuestion.cutType == 3) {
				this.activeQuestion.cutType = 4;
				this.activeQuestion.questionsTypeId = '10';
			} else if (this.activeQuestion.cutType == 7) {
				this.activeQuestion.cutType = 8;
			}
		},
		matrixRadioSwitch() {
			this.activeQuestion.cutType = 5;
			this.activeQuestion.questionsTypeId = '19';
		},
		matrixMultipleChoiceSwitch() {
			this.activeQuestion.cutType = 6;
			this.activeQuestion.questionsTypeId = '20';
		},
		// 修改---

		hover(index) {
			return index == this.editIndex;
		},

		setMatrixColumn(item) {
			let params = {
				that: this,
				url: this.$config.service.setMatrixColumn,
				data: {
					id: this.questionID,
					orders: item.orders,
					labelName: item.labelName,
					minLength: item.minLength,
					lengthLimit: item.lengthLimit,
					userAnswer: item.userAnswer,
					columnWidth: item.columnWidth,
					columnWidthUnit: item.columnWidthUnit,
					// ifFillEmpty: ifFillEmpty,
					notAnswer: item.notAnswer
				},
				method: 'POST',
				cb(res) {
					if (res.code == 0) {
						// console.log(res);
					}
				}
			};
			this.$util.request(params);
		},
		getQuestionNumber(id) {
			return this.question_number[id];
		},
		// 题库
		loadWjTypes() {
			let that = this;
			let params = {
				that: this,
				url: this.$config.service.queryQuestionTypes,
				data: {},
				method: 'POST',
				cb(res) {
					if (res.code == 0) {
						that.wjTypeList = res.resultBody.datas;
						return;
					}
					that.$message.error(res.message);
				}
			};
			this.$util.request(params);
		},
		loadLibraryQuestionList(index, item) {
			this.centerDialogVisible = true;
			this.typeIndex = index;
			this.curTkType = item;
			let that = this;
			let params = {
				that: this,
				url: this.$config.service.queryTestQuestions,
				data: {
					questionTypeId: item.id,
					questionsName: that.searchQuestionsName
				},
				method: 'POST',
				cb(res) {
					if (res.code == 0) {
						that.tkList = res.resultBody.datas;
						return;
					} else {
						that.tkList = [];
					}
				}
			};
			this.$util.request(params);
		},

		selectIcon(index, id, index2) {
			this.outerLayer = index2;
			// console.log("输出外层循环下标", index2);
			this.selectIndexicon = index;
		},

		// 选项关联start
		setOptionAssociation() {
			this.setOptionAssociationList();
			this.questionRelationList = JSON.parse(JSON.stringify(this.activeQuestion.relation));
			this.AssociationShow = true;
		},
		setOptionAssociationList() {
			this.optionAssociationList = [];
			let quesTypeArr = ['8', '9', '10'];
			let list = this.paper.questionsList;
			for (let i = 0; i < list.length; i++) {
				if (list[i].qid == this.activeQuestion.qid) {
					break;
				}
				if (quesTypeArr.indexOf(list[i].questionsTypeId) !== -1) {
					this.optionAssociationList.push(list[i]);
				}
			}
		},
		saveAssociation() {
			this.activeQuestion.relation = JSON.parse(JSON.stringify(this.questionRelationList));
			// console.log(this.activeQuestion.relation);
			this.AssociationShow = false;
		},
		relationVisibleChange(e) {
			if (e) {
				this.setOptionAssociationList();
				let newListArr = [];
				let newListArr2 = [];
				this.questionRelationList.forEach(info => {
					newListArr.push(info.id);
				});
				newListArr2 = this.optionAssociationList.filter(item => {
					if (newListArr.indexOf(item.qid) == -1) {
						return item;
					}
				});
				this.optionAssociationList = newListArr2;
				// console.log(this.optionAssociationList);
			}
		},
		relationChange(e) {
			this.paper.questionsList.forEach(info => {
				if (info.qid == e && info.associated.indexOf(this.activeQuestion.qid) == -1) {
					info.associated.push(this.activeQuestion.qid);
				}
			});
		},
		addAssociation() {
			this.questionRelationList.push({ id: '' });
		},
		removeAssociation(item) {
			// console.log(item);
			var index = this.questionRelationList.indexOf(item);
			// console.log(index);
			if (index !== -1) {
				this.questionRelationList.splice(index, 1);
				this.paper.questionsList.forEach(info => {
					if (info.qid == item.id) {
						let elIndex = info.associated.indexOf(this.activeQuestion.qid);
						if (elIndex !== -1) {
							info.associated.splice(elIndex, 1);
						}
					}
				});
			}
			if (this.questionRelationList.length <= 0) {
				this.questionRelationList.push({ id: '' });
			}
			this.relationVisibleChange(true);
		},
		// 选项关联end
		// 问题编码设置
		quesCodeChange(valueActive) {
			let index = this.paper.questionsList.findIndex(item => {
				return valueActive && item.quesCode == valueActive;
			});
			if (index !== -1) {
				this.$refs.quesCodeInput.setPopoverShow();
			} else {
				this.$refs.quesCodeInput.setPopoverHide();
			}
		},
		// 批量添加保存
		saveAddOptions(addOptions) {
			let optionList = [];
			if (addOptions.length > 0) {
				var q = this.getQuestionById(this.editCurQuestion.id);
				var s = addOptions.split('\n');
				if (s.length > 0) {
					for (let i = 0; i < s.length; i++) {
						s[i] = s[i].replace(/\s/g, '');
						if (s[i] != '') {
							optionList.push(s[i]);
						}
					}
				}
			}

			if (optionList.length == 0) {
				this.$message.warning(this.$t('main.EnterAtLeastOneOption'));
				return;
			}
			let batchCloRowUrl = `${this.$config.service.questionaddbatch}`;
			if (this.RectifRow == 11) {
				//行
				batchCloRowUrl = `${this.$config.service.batchAddMatrixRow}`;
			}
			if (this.RectifRow == 22) {
				//列
				batchCloRowUrl = `${this.$config.service.batchAddMatrixColumn}`;
			}
			let that = this;
			let params = {
				that: this,
				url: batchCloRowUrl,
				method: 'POST',
				data: {
					// id:item.id,
					labelNameList: optionList,
					questionsId: q.id,
					stata: 0
				},
				cb(res) {
					let isMatrix = ['19', '20', '21', '22'].indexOf(q.questionsTypeId) > -1 ? true : false;
					if (res.code == 0) {
						that.batchDialog = false;
						if (!isMatrix) {
							if (q.optionList.length == 2) {
								if (
									(q.optionList[0]?.labelName == `${this.$t('main.option')}1` && q.optionList[1]?.labelName == `${this.$t('main.option')}2`) ||
									(q.optionList[0]?.labelName == `${this.$t('main.option')}2` && q.optionList[1]?.labelName == `${this.$t('main.option')}1`)
								) {
									that._wjdelquestionoption(q.optionList, q.optionList[1], 1);
									that._wjdelquestionoption(q.optionList, q.optionList[0], 0);
								}
							}
							for (let i = 0; i < res.resultBody.datas.length; i++) {
								q.optionList.push(res.resultBody.datas[i]);
							}
						} else {
							if (that.RectifRow == 11) {
								for (let i = 0; i < res.resultBody.datas.length; i++) {
									q.questionsSonList.push(res.resultBody.datas[i]);
								}
							} else {
								for (let _q of q.questionsSonList) {
									for (let i = 0; i < res.resultBody.datas.length; i++) {
										let options = res.resultBody.datas[i];
										if (options[0].questionsId == _q.id) {
											for (let j = 0; j < options.length; j++) {
												_q.optionList.push(options[j]);
											}
										}
									}
								}
							}
						}
					}
				}
			};
			this.$util.request(params);
		},
		cancelAddOptions() {
			this.batchDialog = false;
		},
		setActiveOption(e, name) {
			// console.log(e)
			// console.log(name)
			if (this.activeQuestion.questionsTypeId == '19' || this.activeQuestion.questionsTypeId == '20' || this.activeQuestion.questionsTypeId == '22') {
				let j;
				this.activeQuestion.questionsSonList.forEach((info, index) => {
					info.optionList.forEach((el, i) => {
						if (el.oid == this.activeOption.oid) {
							j = i;
						}
					});
					// console.log(info.optionList[j][name])
					info.optionList[j][name] = e;
				});
			}
			let typeArr = ['19', '20', '21', '22'];
			if (typeArr.indexOf(this.activeQuestion.questionsTypeId) !== -1) {
				this.setOptionDefault();
			}
		},
		setOptionDefault() {
			this.activeQuestion.questionsSonList = this.activeQuestion.questionsSonList.map(info => {
				info.optionList = info.optionList.map(val => {
					this.$set(val, 'isDefault', false);
					return val;
				});
				return info;
			});
		},
		tianEmpty(item) {
			let that = this;
			that.setIfFillEmptyOptions.map(temp => {
				let tempId = temp.id;
				temp.optionList.map(val => {
					if (val.labelName == item.labelName) {
						let params = {
							that: this,
							url: `${this.$config.service.setIfLengthLimit}`,
							method: 'POST',
							data: {
								id: tempId,
								ifLengthLimit: item.ifLengthLimit,
								optionId: val.id
							},
							cb(res) {
								if (res.code == 0) {
									// console.log('限制内容', res);
								}
							}
						};
						this.$util.request(params);
					}
				});
			});
		},
		/**
		 *   @prams question 当前题
		 *   @prams option 需设置当前题选项
		 *   @prams index 需设置当前题选项下标
		 *   @prams index 需设置当前题类型
		 */
		wjsetquestionoption(question, option, index, type) {
			this.isOptionSetting = false;
			if (type == this.$t('main.matrix')) {
				this.activeOption = this.activeQuestion.questionsSonList[0].optionList[index];
			} else {
				this.activeQuestion.optionList.forEach(info => {
					if (info.oid == option.oid) {
						this.activeOption = info;
					}
				});
			}
			// console.log(this.activeQuestion)
			// console.log(this.isOptionSetting)
			// console.log(this.activeOption.labelName)
		},
		setrect(questionsSonList, options, item, childindex, jz, id) {
			// console.log(jz);
			this.setIfFillEmptyOptions = questionsSonList;
			this.jz = jz;
			this.questionID = id;
			this.isOptionSetting = false;
			this.optionmyEmit = options[childindex];
			// console.log("选项设置", this.optionmyEmit);
			// console.log("setIfFillEmptyOptions", this.setIfFillEmptyOptions);
		},
		//应用于所有分页
		applyToAl() {
			// console.log(this.activeQuestion);
			this.paper.questionsList.forEach(info => {
				if (info.questionsTypeId == '26') {
					info.minTimeSwitch = this.activeQuestion.minTimeSwitch;
					info.minTime = this.activeQuestion.minTime;
					info.maxTimeSwitch = this.activeQuestion.maxTimeSwitch;
					info.maxTime = this.activeQuestion.maxTime;
				}
			});
			this.$message({
				message: this.$t('main.SuccessfullyAppliedToAll'),
				type: 'success'
			});
		},

		// 保存分组
		groupSave() {
			let result = false;
			this.groupQuery.forEach(info => {
				if (info.optionList.length == 0) {
					result = true;
					this.$message.error(info.groupName + this.$t('main.NoOptionsAvailable'));
				}
			});
			if (!result) {
				this.activeQuestion.groupingOptionList = JSON.parse(JSON.stringify(this.groupQuery));
				this.activeQuestion.optionList = JSON.parse(JSON.stringify(this.optionGroup));
				this.grouping = false;
			}
		},
		// 添加到分组中
		clickAdd(val) {
			// console.log(val, this.checkedCities);
		},
		// 删除
		deleItem(item, index) {
			this.groupQuery.splice(index, 1);
			this.optionGroup = [...this.optionGroup, ...item.optionList];
		},
		// 下移
		onDownItem(item, index) {
			this.groupQuery.splice(index + 2, 0, item);
			this.groupQuery.splice(index, 1);
		},
		// 上移
		onUpItem(item, index) {
			// console.log("111", item, index);
			this.groupQuery.splice(index - 1, 0, item);
			this.groupQuery.splice(index + 1, 1);
		},
		existGroupName(name) {
			//判断是否存在指定的分组名称
			for (let i = 0; i < this.groupQuery.length; i++) {
				if (this.groupQuery[i].groupName == name) {
					return true;
				}
			}
			return false;
		},
		// 分组搜索
		groupSearchInput() {
			this.groupSearchList = this.optionGroup.filter(item => {
				// console.log(item.labelName.indexOf(this.groupSearch));
				if (item.labelName.indexOf(this.groupSearch) !== -1) {
					return item;
				}
			});
		},
		// 添加分组
		addGroup() {
			var newGroup = {};
			var groupName = '';
			for (let i = 0; i <= this.groupQuery.length; i++) {
				groupName = this.$t('main.subset') + (i + 1);
				if (this.existGroupName(groupName)) {
					continue;
				} else {
					break;
				}
			}
			newGroup.groupName = groupName;
			newGroup.optionList = [];
			newGroup.gid = UUID();
			this.groupQuery.push(newGroup);
			// console.log(this.groupQuery);
		},
		jiaru(index) {
			//  console.log(index);
			//加入分组
			this.checkedCities.forEach(e => {
				this.groupQuery[index].optionList.push(e);
			});
			for (let j = 0; j < this.checkedCities.length; j++) {
				for (let i = 0; i < this.optionGroup.length; i++) {
					if (this.optionGroup[i].oid == this.checkedCities[j].oid) {
						//  console.log(this.optionGroup[i], this.checkedCities[j]);
						this.optionGroup.splice(i, 1);
						break;
					}
				}
				for (let i = 0; i < this.groupSearchList.length; i++) {
					if (this.groupSearchList[i].oid == this.checkedCities[j].oid) {
						//  console.log(this.optionGroup[i], this.checkedCities[j]);
						this.groupSearchList.splice(i, 1);
						break;
					}
				}
			}
			this.checkedCities = [];
		},
		removeOptionGroup(optionList, item, index) {
			this.optionGroup.push(item);
			optionList.splice(index, 1);
		},
		groupSetting() {
			// console.log(id);
			this.groupQuery = JSON.parse(JSON.stringify(this.activeQuestion.groupingOptionList));
			this.optionGroup = JSON.parse(JSON.stringify(this.activeQuestion.optionList));
			this.grouping = true;
		},

		Contentheng(value, id, e) {
			// console.log('下拉输出', value, id, e);
		},
		close() {
			this.hiden = false;
		},
		setBlank(id) {
			this.hiden = true;
			let that = this;
			let params = {
				that: this,
				url: `${this.$config.service.selectOption}`,
				method: 'POST',
				data: {
					id: id
				},
				cb(res) {
					if (res.code == 0) {
						that.hengoption = res.resultBody.datas;
						// console.log('弹框选项内容', res);
					}
				}
			};
			this.$util.request(params);
		},
		// wjChangeBlank(item, id) {
		//   console.log("修改横向填空", item, id);
		//   let that = this;
		//   let params = {
		//     that: this,
		//     url: `${this.$config.service.changeOption}`,
		//     method: "POST",
		//     data: {
		//       id: id,
		//       labelName: item,
		//     },
		//     cb(res) {
		//       if (res.code == 0) {
		//         that.reload();
		//         console.log("输出", res);
		//       }
		//     },
		//   };
		//   this.$util.request(params);
		// },
		choiceNum(val, id) {},

		loadAskTypeData() {
			let that = this;
			let params = {
				that: this,
				url: this.$config.service.questionTypeList,
				data: {},
				cb(res) {
					if (res.code == 0) {
						that.typeObj = res.resultBody.questionTypeOneList;
						that.typeObj = that.typeObj.map((info) => {
							info.questionTypeList = info.questionTypeList.map(val => {
								val.type = val.type.toString()
								return val
							})
							return info
						})
					}
				}
			};
			this.$util.request(params);
		},
		//题库添加问题
		addTkItem(item) {
			let that = this;
			let editIndex;
			// console.log("edit index  =====> ", this.editIndex);
			if (this.editIndex > this.paper.questionsList.length - 1 || this.editIndex == -1) {
				editIndex = this.paper.questionsList.length - 1;
			} else {
				editIndex = this.editIndex;
			}
			let lastIndex;

			let params = {
				that: this,
				url: this.$config.service.addNewQuestions,
				data: {
					questionnaireId: that.wid,
					editIndex: editIndex,
					lastIndex: editIndex,
					questions: [item.id]
				},
				method: 'POST',
				cb(res) {
					// console.log('题库', res);
					if (res.code == 0) {
						that.loadQuestionList();
						that.$message.success(that.$t('main.AddedSuccessfully'));
						// console.log("editIndex ====== > ", that.editIndex);
						if (that.editIndex >= 0) {
							that.paper.questionsList.splice(that.editIndex + 1, 0, res.resultBody);
							//joery:将新增问题设置为选中
							that.setEditIndex(that.editIndex + 1);
							//that.editIndex = that.editIndex+1;
						} else {
							that.paper.questionsList.push(res.resultBody);
							//joery:新增问题设置为选中
							that.setEditIndex(that.paper.questionsList.length - 1);
							//that.editIndex = that.questionlist.length-1;
						}

						if (that.editIndex < 0) {
							setTimeout(() => {
								let div = document.getElementById('wenjuan_list');
								div.scrollTop = div.scrollHeight;
							}, 400);
						}

						that.centerDialogVisible = false;
						return;
					}

					that.$message.error(res.message);
				}
			};
			this.$util.request(params);
		},
		wjinfo(callback) {
			// console.log('wjinfo')
			// let that = this;
			// let id = that.wid;
			// let params = {
			//   that: this,
			//   url: `${this.$config.service.wjinfo}?id=${id}`,
			//   method: "POST",
			//   cb(res) {
			//     if (res.code == 0) {
			//       that.curWjInfo = res.resultBody;
			//       // 获取问卷的标题与描述
			//       that.questionContent = that.curWjInfo.content;
			//       that.questionWjTitle = that.curWjInfo.wjTitle;
			//       // that.loadQuestionList(callback);
			//     }
			//   },
			// };
			// this.$util.request(params);
		},
		wjedit() {
			// let that = this;
			// if (that.curWjInfo != null) {
			//   if (
			//     that.curWjInfo.content == that.questionContent &&
			//     that.curWjInfo.wjTitle == that.questionWjTitle
			//   ) {
			//     return;
			//   }
			// }
			// let params = {
			//   that: this,
			//   url: this.$config.service.wjedit,
			//   data: {
			//     content: that.curWjInfo.content,
			//     wjTitle: that.curWjInfo.wjTitle,
			//     id: that.curWjInfo.id,
			//   },
			//   cb(res) {
			//     if (res.code == 0) {
			//       that.$message.success(res.message);
			//       // 修改成功以后重新赋值
			//       that.questionWjTitle = that.curWjInfo.wjTitle;
			//       that.questionContent = that.curWjInfo.content;
			//     }
			//   },
			// };
			// this.$util.request(params);
		},
		loadQuestionList() {
			// console.log(this.wid);
			if (this.isTemplate) {
				this.getTampPaperJson();
			} else {
				this.getProjectPaperJson();
			}
		},
		getProjectPaperJson() {
			let that = this;
			let params = {
				that: this,
				url: `${this.$config.service.questionlist}?id=${this.wid}`,
				method: 'GET',
				data: {},
				cb(res) {
					that.loading = false;
					that.paperReturnSuccess = true;
					if (res.code == 0) {
						if (res.resultBody.tbExamPaper) {
							let paper = JSON.parse(res.resultBody.tbExamPaper.paperjson);
							paper.title = res.resultBody.wjTitle;
							for (let key in paper) {
								that.paper[key] = paper[key];
							}
							that.setInitLogicalSettings();
						}
					}
				}
			};
			this.$util.request(params);
		},
		setInitLogicalSettings() {
			this.paper.questionsList = this.paper.questionsList.map(info => {
				if (!info.logicalSettings) {
					this.paper.initlogicalSettings(info);
				}
				return info;
			});
		},
		getTampPaperJson() {
			console.log(this.$config.service.questionnaireDetail);
			let that = this;
			let params = {
				that: this,
				url: `${this.$config.service.questionnaireDetail}?id=${this.wid}`,
				method: 'GET',
				data: {},
				cb(res) {
					that.loading = false;
					that.paperReturnSuccess = true;
					if (res.code == 0) {
						let paper = JSON.parse(res.resultBody.paperjson);
						for (let key in paper) {
							that.paper[key] = paper[key];
						}
						that.setInitLogicalSettings();
					}
				}
			};
			this.$util.request(params);
		},
		// 删除题 删除行
		questiondel(qid, SonId, associated) {
			if (this.activeQuestion.questionsTypeId != '25' && this.activeQuestion.questionsTypeId != '26' && this.activeQuestion.logicalSettings.num > 0) {
				this.$message.warning(this.$t('main.questionHasAlreadyParticipatedInLogicalSetting'));
				return;
			}
			// console.log(qid, SonId, associated)
			if (associated && associated.length > 0) {
				this.$message.warning(this.$t('main.questionOptionIsAlreadyAssociatedWithAnotherQuestion'));
				return;
			}
			//第一页不能删除
			if (this.activeQuestion.questionsTypeId == '26' && this.activeQuestion.pageNumber == 1) {
				this.$message.warning(this.$t('main.firstPageIsTheDefaultPage'));
				return;
			}

			this.$confirm(this.$t('main.operationWillPermanentlyDeleteTheData'), this.$t('main.tip'), {
				confirmButtonText: this.$t('main.ok'),
				cancelButtonText: this.$t('main.cancel'),
				type: 'info'
			})
				.then(() => {
					let parent;
					if (typeof SonId != 'undefined') {
						parent = this.getQuestionById(qid);
						let children = parent.questionsSonList;
						for (let index = 0; index < children.length; index++) {
							if (children[index].SonId == SonId) {
								children.splice(index, 1);
								break;
							}
						}
					} else {
						//第一页不能删除
						if (this.activeQuestion.questionsTypeId == '26' && this.paper.pageCount == 2) {
							this.paper.delQuestion(this.paper.questionsList[0].qid);
						}
						// 在删除之前 清除被关联绑定的试题id组
						if (typeof this.activeQuestion.relation != 'undefined') {
							this.activeQuestion.relation.forEach(val => {
								this.paper.questionsList.forEach(info => {
									if (val.id == info.qid) {
										let index = info.associated.indexOf(qid);
										info.associated.splice(index, 1);
									}
								});
							});
						}
						this.paper.delQuestion(qid);
						this.activeQuestion = {};
					}
				})
				.catch(() => {
					this.$message({
						type: 'info',
						message: this.$t('main.CancelledDeletion')
					});
				});
		},
		setEditIndex(index) {
			if (index != undefined) {
				if (this.activeQuestion.qid != this.paper.questionsList[index].qid) {
					this.paper.cancleEdit();
					this.paper.questionsList[index].isedit = true;
				}
			}
			this.isOptionSetting = true;
			this.editIndex = index; // 当前选中的试题下标
		},
		setEditOptionIndex(childIndex) {
			this.editOptionIndex = this.editIndex + '_' + childIndex;
		},
		// 选择的添加选项
		// batchAdd(options, item, jz, questionId, ifRow) {
		//   this.RectifRow = "";
		//   console.log("options, item", options, item, questionId, ifRow);
		//   this.RectifRow = ifRow;
		//   if (options.length == 2) {
		//     if (
		//       (options[0]?.labelName == "选项1" &&
		//         options[1]?.labelName == "选项2") ||
		//       (options[0]?.labelName == "选项2" && options[1]?.labelName == "选项1")
		//     ) {
		//       this.batch_placeholder = "选项1\n选项2";
		//     } else {
		//       this.batch_placeholder = "";
		//     }
		//   } else {
		//     this.batch_placeholder = "";
		//   }

		//   this.batchDialog = true;
		//   this.editCurQuestion = item;
		//   this.addOptions = [];
		//   console.log("批量添加选项", options);
		// },
		addOptionToElseGroup(item, option) {
			//将问题选项添加到其他组里
			// console.log(item, option);
			for (let i = 0; i < item.groupingOptionList.length; i++) {
				if (item.groupingOptionList[i].groupName == this.$t('main.other')) {
					item.groupingOptionList[i].questionsOptionVOS.push(option);
				}
			}
		},
		// 批量添加选项
		wjaddquestionoption(qid, Arr, qType, haveInput) {
			// console.log('添加选项');
			// 批量添加
			this.paper.questionsList.forEach(item => {
				if (qid === item.qid) {
					Arr.forEach(info => {
						if (qType == '35') {
							item.optionList.push({
								oid: UUID(),
								labelName: info,
								notAnswer: true,
								format: 0,
								minNum: 0, //最少填写
								maxNum: 0, // 字数限制
								decimalPlaces: 0, // 字数限制
								userAnswer: '', // 默认文本
								inputHeight: this.$t('main.small'),
								isDefault: false // 默认添加的选项
							});
						} else {
							let option = {
								oid: UUID(),
								labelName: info,
								haveInput: haveInput ? haveInput : false,
								inputValue: '',
								isDefault: false
							};
							if (item?.scoreOrNot == 1) {
								option.optionScore = 5;
							}
							item.optionList.push(option);
						}
					});
				}
			});
		},
		//删除选项列,无提示,不刷新
		_wjdelquestionoption(options, item, childindex) {
			let that = this;
			let params = {
				that: this,
				url: `${this.$config.service.deloneoption}?id=${item.id}`,
				data: {},
				cb(res) {
					if (res.code == 0) {
						let index = options.findIndex(opt => opt.id == item.id);
						if (index > -1) {
							options.splice(index, 1);
						}
					}
				}
			};
			this.$util.request(params);
		},
		//删除选项
		wjdelquestionoption(obj, index) {
			// console.log("删除选项", { options, item, childindex })

			this.$confirm(this.$t('main.operationWillPermanentlyDeleteTheData'), this.$t('main.tip'), {
				confirmButtonText: this.$t('main.ok'),
				cancelButtonText: this.$t('main.cancel'),
				type: 'info'
			})
				.then(() => {
					for (var j = 0; j < this.paper.questionsList.length; j++) {
						if (obj.qid == this.paper.questionsList[j].qid) {
							var optionList = this.paper.questionsList[j].optionList;
							for (var i = 0; i < optionList.length; i++) {
								// console.log(optionList)
								if (this.paper.questionsList[j].groupingOptionList) {
									let index = 0;
									index = optionList.findIndex(el => {
										return el.oid == obj.oid;
									});
									// console.log(index);
									// console.log(obj.oid);
									if (index == -1) {
										this.$message({
											message: this.$t('main.PleaseRemoveTheOptionFromTheGroup'),
											type: 'warning'
										});
									} else {
										if (obj.oid == optionList[i].oid) {
											optionList.splice(i, 1);

											this.$message({
												message: this.$t('main.SuccessfullyDeletedThePption'),
												type: 'success'
											});
											break;
										}
									}
								} else {
									if (obj.oid == optionList[i].oid) {
										optionList.splice(i, 1);
										this.$message({
											message: this.$t('main.SuccessfullyDeletedThePption'),
											type: 'success'
										});
										break;
									}
								}
							}
						}
					}
				})
				.catch(() => {
					this.$message({
						type: 'info',
						message: this.$t('main.CancelledDeletion')
					});
				});
		},

		deleteOptionColumn(obj) {
			this.$confirm(this.$t('main.operationWillPermanentlyDeleteTheData'), this.$t('main.tip'), {
				confirmButtonText: this.$t('main.ok'),
				cancelButtonText: this.$t('main.cancel'),
				type: 'info'
			})
				.then(() => {
					let questionsSonList = this.activeQuestion.questionsSonList;
					for (var i = 0; i < questionsSonList.length; i++) {
						questionsSonList[i].optionList.splice(obj.index, 1);
					}
				})
				.catch(() => {
					this.$message({
						type: 'info',
						message: this.$t('main.CancelledDeletion')
					});
				});
		},
		// 添加一矩阵行
		addRows(text) {
			let length = this.activeQuestion.questionsSonList.length;
			let length2 = this.activeQuestion.questionsSonList[0].optionList.length;
			let questionsSonList = new Object();
			questionsSonList.SonId = UUID();
			questionsSonList.questionsName = `${this.$t('main.MatrixRow')}${length + 1}`;
			if (this.activeQuestion.questionsTypeId == '19') {
				questionsSonList.isSelected = '';
			} else if (this.activeQuestion.questionsTypeId == '20') {
				questionsSonList.isSelected = [];
			}
			let haveInputArr = [],
				oidArr = [],
				labelNameArr = [];
			this.activeQuestion.questionsSonList[0].optionList.forEach((e, i) => {
				if (e?.haveInput == true) {
					haveInputArr.push(i);
				}
				oidArr.push(e.oid);
				labelNameArr.push(e.labelName);
			});
			questionsSonList.optionList = new Array();
			for (var i = 0; i < length2; i++) {
				let option = new Object();
				option.oid = oidArr[i];
				option.labelName = labelNameArr[i];
				if (this.activeQuestion.questionsTypeId == '19' || this.activeQuestion.questionsTypeId == '20') {
					if (haveInputArr.indexOf(i) !== -1) {
						option.haveInput = true;
					} else {
						option.haveInput = false;
					}
					option.inputValue = '';
					option.format = 0; // 内容限制
					option.isMaxNum = false; // 字数限制开关
					option.minNum = 0; //最少填写
					option.maxNum = 0; // 字数限制
					option.decimalPlaces = 0; // 字数限制
					option.notAnswer = true; // 该空可不填
				} else if (this.activeQuestion.questionsTypeId == '21') {
					option.ratingScore = 0;
				} else if (this.activeQuestion.questionsTypeId == '22') {
					option.minNum = 0; //最少填写
					option.maxNum = 0; // 字数限制
					option.decimalPlaces = 0; // 字数限制
					option.userAnswer = ''; // 默认文本
					option.notAnswer = false; // 该空可不填
				}
				questionsSonList.optionList.push(option);
			}
			this.activeQuestion.questionsSonList.push(questionsSonList);
		},
		// 添加一矩阵列
		addColumn(text) {
			let length = this.activeQuestion.questionsSonList[0].optionList.length;
			let option = new Object();
			option.oid = UUID();
			option.labelName = text ? text + (length + 1) : this.$t('main.option') + (length + 1);
			if (this.activeQuestion.questionsTypeId == '19' || this.activeQuestion.questionsTypeId == '20') {
				option.haveInput = false;
				option.inputValue = '';
				option.format = 0; // 内容限制
				option.isMaxNum = false; // 字数限制开关
				option.minNum = 0; //最少填写
				option.maxNum = 0; // 字数限制
				option.decimalPlaces = 0; // 字数限制
				option.notAnswer = true; // 该空可不填
			} else if (this.activeQuestion.questionsTypeId == '21') {
				option.ratingScore = 0;
			} else if (this.activeQuestion.questionsTypeId == '22') {
				option.minNum = 0; //最少填写
				option.maxNum = 0; // 字数限制
				option.decimalPlaces = 0; // 字数限制
				option.userAnswer = ''; // 默认文本
				option.notAnswer = false; // 该空可不填
			}
			let copyOption = JSON.parse(JSON.stringify(option));
			this.activeQuestion.questionsSonList.forEach((info, index) => {
				info.optionList.push(copyOption);
			});
			// console.log(`添加一列`);
			// console.log(this.activeQuestion.questionsSonList);
		},
		// 批量添加矩阵行
		batchAddRows(arr) {
			arr.forEach((item, index) => {
				let length2 = this.activeQuestion.questionsSonList[0].optionList.length;
				let haveInputArr = [],
					oidArr = [],
					labelNameArr = [],
					isDefaultArr = [];
				this.activeQuestion.questionsSonList[0].optionList.forEach((e, i) => {
					if (e?.haveInput == true) {
						haveInputArr.push(i);
					}
					isDefaultArr.push(e.isDefault);
					oidArr.push(e.oid);
					labelNameArr.push(e.labelName);
				});
				// console.log(haveInputArr);
				let questionsSonList = new Object();
				questionsSonList.SonId = UUID();
				questionsSonList.isDefault = false;
				questionsSonList.questionsName = item;
				if (this.activeQuestion.questionsTypeId == '19') {
					questionsSonList.isSelected = '';
				} else if (this.activeQuestion.questionsTypeId == '20') {
					questionsSonList.isSelected = [];
				}
				questionsSonList.optionList = new Array();
				console.log(oidArr);
				for (var i = 0; i < length2; i++) {
					let option = new Object();
					option.oid = oidArr[i];
					option.isDefault = isDefaultArr[i];
					option.labelName = labelNameArr[i];
					if (this.activeQuestion.questionsTypeId == '19' || this.activeQuestion.questionsTypeId == '20') {
						if (haveInputArr.indexOf(i) !== -1) {
							option.haveInput = true;
						} else {
							option.haveInput = false;
						}
						option.inputValue = '';
						option.format = 0; // 内容限制
						option.isMaxNum = false; // 字数限制开关
						option.minNum = 0; //最少填写
						option.maxNum = 0; // 字数限制
						option.decimalPlaces = 0; // 字数限制
						option.notAnswer = true; // 该空可不填
					} else if (this.activeQuestion.questionsTypeId == '21') {
						option.ratingScore = 0;
					} else if (this.activeQuestion.questionsTypeId == '22') {
						option.minNum = 0; //最少填写
						option.maxNum = 0; // 字数限制
						option.decimalPlaces = 0; // 字数限制
						option.userAnswer = ''; // 默认文本
						option.notAnswer = false; // 该空可不填
					}
					let copyOption = JSON.parse(JSON.stringify(option));
					questionsSonList.optionList.push(copyOption);
				}
				this.activeQuestion.questionsSonList.push(questionsSonList);
			});
		},
		// 批量添加矩阵列
		batchAddColumns(arr) {
			arr.forEach((item, index) => {
				let option = new Object();
				option.oid = UUID();
				option.isDefault = false;
				option.labelName = item;
				if (this.activeQuestion.questionsTypeId == '19' || this.activeQuestion.questionsTypeId == '20') {
					option.haveInput = false;
					option.inputValue = '';
					option.format = 0; // 内容限制
					option.isMaxNum = false; // 字数限制开关
					option.minNum = 0; //最少填写
					option.maxNum = 0; // 字数限制
					option.decimalPlaces = 0; // 字数限制
					option.notAnswer = true; // 该空可不填
				} else if (this.activeQuestion.questionsTypeId == '21') {
					option.ratingScore = 0;
				} else if (this.activeQuestion.questionsTypeId == '22') {
					option.minNum = 0; //最少填写
					option.maxNum = 0; // 字数限制
					option.decimalPlaces = 0; // 字数限制
					option.userAnswer = ''; // 默认文本
					option.notAnswer = false; // 该空可不填
				}

				let copyOption = JSON.parse(JSON.stringify(option));
				this.activeQuestion.questionsSonList.forEach((info, index) => {
					info.optionList.push(copyOption);
				});
			});
		},
		// mustAnswer(id) {
		//   let that = this;
		//   let params = {
		//     that: this,
		//     url: `${this.$config.service.setupifmustanswer}`,
		//     method: "POST",
		//     data: {
		//       id: id,
		//     },
		//     cb(res) {
		//       if (res.code == 0) {
		//         console.log("设置成功后输出", that.ifMustAnswer);
		//         that.loadQuestionList();
		//       }
		//     },
		//   };
		//   this.$util.request(params);
		// },
		// setInputSize(index, id) {
		//   this.currentSort = index;
		//   console.log("点击时输出", index);
		//   console.log("1", id);
		//   let inputSize = 0;
		//   if (index == 0 || index == 3) {
		//     inputSize = 30;
		//   } else if (index == 1 || index == 4) {
		//     inputSize = 60;
		//   } else if (index == 2 || index == 5) {
		//     inputSize = 90;
		//   }
		//   let that = this;
		//   let params = {
		//     that: this,
		//     url: `${this.$config.service.setInputBoxSize}`,
		//     method: "POST",
		//     data: {
		//       id: id,
		//       inputBoxSize: inputSize,
		//     },
		//     cb(res) {
		//       if (res.code == 0) {
		//         console.log("输出", res);

		//         that.loadQuestionList();
		//       }
		//     },
		//   };
		//   this.$util.request(params);
		// },
		//选择范围 最少
		upleast() {
			if (this.activeQuestion.minOptionsNum > this.activeQuestion.maxOptionsNum) {
				if (this.activeQuestion.maxOptionsNum != 0) {
					this.$message.error(this.$t('main.minimumOptionsCannotExceedTheMaximumOptions'));
					return;
				}
			}
		},
		//选择范围 最多
		upmost() {
			if (this.activeQuestion.minOptionsNum > this.activeQuestion.maxOptionsNum) {
				if (this.activeQuestion.maxOptionsNum != 0) {
					this.$message.error(this.$t('main.minimumOptionsCannotExceedTheMaximumOptions'));
					return;
				}
			}
		},
		contents(val, id) {
			// console.log('改变输出', val, id);
			let that = this;
			let params = {
				that: this,
				url: `${this.$config.service.setIfLengthLimit}`,
				method: 'POST',
				data: {
					id: id,
					ifLengthLimit: val
				},
				cb(res) {
					if (res.code == 0) {
						// console.log('输出哈哈哈', res);
					}
				}
			};
			this.$util.request(params);
		},
		// 单行输入框切换多行输入框
		switchoverType(num, id) {
			this.questionlineRank = num;
			var q = this.getQuestionById(id);
			let that = this;
			let params = {
				that: this,
				url: `${this.$config.service.questionInputBox}`,
				method: 'POST',
				data: {
					id: id,
					inputBoxSetting: num
				},
				cb(res) {
					if (res.code == 0) {
						//that.reload()
						q.inputBoxSetting = num;
					}
				}
			};
			this.$util.request(params);
		},
		// inpLeast(value, id) {
		//   let that = this;
		//   let params = {
		//     that: this,
		//     url: `${this.$config.service.setupleast}`,
		//     method: "POST",
		//     data: {
		//       id: id,
		//       least: value,
		//     },
		//     cb(res) {
		//       if (res.code == 0) {
		//         console.log("输出", res);
		//         that.paper.questionsList[that.editIndex].least = Number(value);
		//         // console.log(that.questionlist)
		//       }
		//     },
		//   };
		//   this.$util.request(params);
		// },
		// 添加问卷
		wjadd() {
			let that = this;
			let params = {
				that: this,
				url: this.$config.service.wjadd,
				data: {
					content: '',
					wjTitle: this.paper.title,
					wjType: '问卷类型',
					id: this.wid
				},
				cb(res) {
					that.loading = false;
					// console.log(res);
					if (res.code == 0) {
						that.curWjInfo = res.resultBody;
						sessionStorage.setItem('wid', that.curWjInfo.id);
						sessionStorage.setItem('wstate', that.curWjInfo.state);
						that.wid = that.curWjInfo.id;
						that.loadQuestionList();
					}
				}
			};
			this.$util.request(params);
		},
		// inpMoster(value, id) {
		//   let that = this;
		//   let params = {
		//     that: this,
		//     url: `${this.$config.service.setupmost}`,
		//     method: "POST",
		//     data: {
		//       id: id,
		//       most: value,
		//     },
		//     cb(res) {
		//       if (res.code == 0) {
		//         console.log("输出", res);
		//         that.paper.questionsList[that.editIndex].most = Number(value);
		//         // that.inputMoster = that.questionlist[that.editIndex].most;
		//       }
		//     },
		//   };
		//   this.$util.request(params);
		// },
		// setupmost(value, id) {
		//   let that = this;
		//   let params = {
		//     that: this,
		//     url: `${this.$config.service.setupmost}`,
		//     method: "POST",
		//     data: {
		//       id: id,
		//       most: value,
		//     },
		//     cb(res) {
		//       if (res.code == 0) {
		//         // editCurQuestion.most = value;
		//       }
		//     },
		//   };
		//   this.$util.request(params);
		// },
		// setupleast(value, id) {
		//   let params = {
		//     that: this,
		//     url: `${this.$config.service.setupleast}`,
		//     method: "POST",
		//     data: {
		//       id: id,
		//       least: value,
		//     },
		//     cb(res) {
		//       if (res.code == 0) {
		//         console.log("输出", res);
		//       }
		//     },
		//   };
		//   this.$util.request(params);
		// },
		// RandomArr(id, value) {
		//   let that = this;
		//   let params = {
		//     that: this,
		//     url: `${this.$config.service.setupoptionifrandom}`,
		//     method: "POST",
		//     data: {
		//       id: id,
		//       content: value,
		//     },
		//     cb(res) {
		//       if (res.code == 0) {
		//         that.$message.success("设置成功！");
		//         that.paper.questionsList[that.editIndex].optionIfRandom = value;
		//       } else {
		//         that.$message.error(res.message);
		//       }
		//     },
		//   };
		//   this.$util.request(params);
		// },
		// fixation(id, value) {
		//   let that = this;
		//   let params = {
		//     that: this,
		//     url: `${this.$config.service.fixedlastoption}`,
		//     method: "POST",
		//     data: {
		//       id: id,
		//       content: value,
		//     },
		//     cb(res) {
		//       if (res.code == 0) {
		//         that.$message.success("设置成功！");
		//         that.paper.questionsList[that.editIndex].ifFixedLastOption = value;
		//       } else {
		//         that.$message.error(res.message);
		//       }
		//     },
		//   };
		//   this.$util.request(params);
		// },

		//单选多选切换
		//   setTopic(index, id) {
		//     console.log("单选多选", index, id);
		//     var q = this.getQuestionById(id);
		//     let that = this;
		//     that.questionsType = index;
		//     var newQuestionsTypeId = q.questionsTypeId;
		//     //获取问题类型
		//     if (q.questionsTypeId == 8 && index == 2) {
		//       that.questionsTypeId = 10;
		//       newQuestionsTypeId = 10;
		//     } else if (q.questionsTypeId == 10 && index == 1) {
		//       that.questionsTypeId = 8;
		//       newQuestionsTypeId = 8;
		//     } else if (q.questionsTypeId == 19 && index == 2) {
		//       that.questionsTypeId = 20;
		//       newQuestionsTypeId = 20;
		//     } else if (q.questionsTypeId == 20 && index == 1) {
		//       that.questionsTypeId = 19;
		//       newQuestionsTypeId = 19;
		//     }
		//   // 图片选择题
		// 	// if (q.questionsTypeId == 6 && index == 2) {
		//  //          // that.questionsTypeId = 10;
		//  //          // newQuestionsTypeId = 10;
		// 	// 	  that.questionsType = index
		// 	// 	  console.log(q.ifMustSingle)
		//  //        } else {

		// 	// 	}

		//     if (
		//       q.questionsTypeId == 8 ||
		//       q.questionsTypeId == 10 ||
		//       q.questionsTypeId == 19 ||
		//       q.questionsTypeId == 20 ||
		//       q.questionsTypeId == 6
		//     ) {
		//       let params = {
		//         that: this,
		//         url: `${this.$config.service.setQuestionsTypeId}`,
		//         method: "POST",
		//         data: {
		//           id: id,
		//           questionsTypeId: newQuestionsTypeId,
		//         },
		//         cb(res) {
		//           if (res.code == 0) {
		//             q.ifMustSingle = index;
		//             q.questionsTypeId = newQuestionsTypeId;
		//           }
		//         },
		//       };
		//       this.$util.request(params);
		//     } else {
		//       if (index == 1) {
		//         let that = this;
		//         let params = {
		//           that: this,
		//           url: `${this.$config.service.setupsingleoption}`,
		//           method: "POST",
		//           data: {
		//             id: id,
		//           },
		//           cb(res) {
		//             if (res.code == 0) {
		//               q.ifMustSingle = index;
		//               //that.reload()
		//               console.log("输出", res);
		//             }
		//           },
		//         };
		//         this.$util.request(params);
		//       } else if (index == 2) {
		//         let that = this;
		//         let params = {
		//           that: this,
		//           url: `${this.$config.service.setupmanyoption}`,
		//           method: "POST",
		//           data: {
		//             id: id,
		//           },
		//           cb(res) {
		//             if (res.code == 0) {
		//               q.ifMustSingle = index;
		//               // that.reload()
		//               console.log("输出", res);
		//             }
		//           },
		//         };
		//         this.$util.request(params);
		//       }
		//     }
		//   },

		setLayout(index, id) {
			this.questionLayout = index;
			// console.log(index, id);
			var q = this.getQuestionById(id);
			let that = this;
			let params = {
				that: this,
				url: `${this.$config.service.choiceLayout}`,
				method: 'POST',
				data: {
					id: id,
					choiceLayout: index
				},
				cb(res) {
					if (res.code == 0) {
						// console.log('输出', res);
						q.choiceLayout = index;
						// that.reload()
					}
				}
			};
			this.$util.request(params);
		},
		betRan(id) {
			let that = this;
			let params = {
				that: this,
				url: `${this.$config.service.setBetweenGroupRandom}`,
				method: 'POST',
				data: {
					id: id
				},
				cb(res) {
					if (res.code == 0) {
						// console.log('输出', res);
					}
				}
			};
			this.$util.request(params);
		},
		inGroupR(id) {
			let that = this;
			let params = {
				that: this,
				url: `${this.$config.service.setInGroupRandom}`,
				method: 'POST',
				data: {
					id: id
				},
				cb(res) {
					if (res.code == 0) {
						// console.log('输出', res);
					}
				}
			};
			this.$util.request(params);
		},
		// manSet(id, e) {
		//   console.log(id, e);
		//   this.$api
		//     .SetManualSetting(id, e)
		//     .then((res) => {
		//       console.log(res);
		//       let question = this.getQuestionById(id);
		//       this.$set(question, "manualSetting", e);
		//     })
		//     .catch((error) => {
		//       console.log(error);
		//     });
		// },

		// setDetails(id, val) {
		//   console.log("城市选择输出", id, val);
		//   let that = this;
		//   let params = {
		//     that: this,
		//     url: `${this.$config.service.setupCitySelection}`,
		//     method: "POST",
		//     data: {
		//       choiceRange: val.value,
		//       questionsId: id,
		//     },
		//     cb(res) {
		//       if (res.code == 0) {
		//         console.log("输出", res);
		//         that.getQuestionById(id).choiceRange = val.value;
		//       }
		//     },
		//   };
		//   this.$util.request(params);
		// },
		// lineMartix(id) {
		//   let that = this;
		//   let params = {
		//     that: this,
		//     url: `${this.$config.service.MatrixLineRandom}`,
		//     method: "POST",
		//     data: {
		//       id: id,
		//     },
		//     cb(res) {
		//       if (res.code == 0) {
		//         that.loadQuestionList();
		//         console.log("输出", res);
		//       }
		//     },
		//   };
		//   this.$util.request(params);
		// },
		// RankMartix(id) {
		//   let that = this;
		//   let params = {
		//     that: this,
		//     url: `${this.$config.service.MatrixRankRandom}`,
		//     method: "POST",
		//     data: {
		//       id: id,
		//     },
		//     cb(res) {
		//       if (res.code == 0) {
		//         that.loadQuestionList();
		//         // console.log('输出',res)
		//       }
		//     },
		//   };
		//   this.$util.request(params);
		// },
		getQuestionById(id) {
			for (var i = 0; i < this.paper.questionsList.length; i++) {
				if (this.paper.questionsList[i].qid == id) {
					return this.paper.questionsList[i];
				}
			}
		},
		getQuestionIndexById(id) {
			for (var i = 0; i < this.paper.questionsList.length; i++) {
				if (this.paper.questionsList[i].id == id) {
					return i;
				}
			}
		},
		// lineRank(id) {
		//   let that = this;
		//   let params = {
		//     that: this,
		//     url: `${this.$config.service.LineRank}`,
		//     method: "POST",
		//     data: {
		//       id: id,
		//     },
		//     cb(res) {
		//       if (res.code == 0) {
		//         // that.$message.success("设置成功！");
		//         // that.loadQuestionList();
		//         // console.log('输出',res)
		//       }
		//     },
		//   };
		//   this.$util.request(params);
		// },
		// 获取关联 的题 的数组
		getOptionRelationTipsByIds(ids) {
			//var idsarray = ids.split(",");
			if (ids.length <= 0) {
				return '';
			}

			var tempStr = this.$t('main.AssociatedFrom');
			for (var i = 0; i < ids.length; i++) {
				var q = this.getQuestionById(ids[i]);
				tempStr += this.getQTagByQuestion(q) + this.$t('main.de') + q.optionList.length + `${this.$t('main.Options')}:`;
				for (var j = 0; j < q.optionList.length; j++) {
					tempStr += q.optionList[j].labelName + '、';
				}
				tempStr += ';';
			}
			return tempStr;
		},
		getQTagByQuestion(q) {
			var qindex = this.getQuestionIndexById(q.id);
			return this.paper.questionsList.length && this.paper.questionsList[0].questionsTypeId == 26 ? 'Q' + (qindex + 1 - q.pageNumber) : 'Q' + (qindex + 1);
		},
		// setTips(value, id, item) {
		//   if (item == "left") {
		//     this.tipsData.left = value;
		//     this.paper.questionsList[this.editIndex].scoreAnnotation = JSON.stringify(
		//       this.tipsData
		//     );
		//   } else if (item == "center") {
		//     this.tipsData.center = value;
		//     this.paper.questionsList[this.editIndex].scoreAnnotation = JSON.stringify(
		//       this.tipsData
		//     );
		//   } else {
		//     this.tipsData.right = value;
		//     this.paper.questionsList[this.editIndex].scoreAnnotation = JSON.stringify(
		//       this.tipsData
		//     );
		//   }
		//   let str = JSON.stringify(this.tipsData);
		//   this.setScoreAnnotation(str, id);
		// },
		// setScoreAnnotation(value, id) {
		//   let params = {
		//     that: this,
		//     url: `${this.$config.service.scoreAnnotation}`,
		//     method: "POST",
		//     data: {
		//       id: id,
		//       scoreAnnotation: value,
		//     },
		//     cb(res) {
		//       if (res.code == 0) {
		//         // console.log("输出", res);
		//         that.paper.questionsList[that.editIndex].scoreAnnotation = value;
		//         // console.log(that.questionlist[that.editIndex].scoreAnnotation)
		//       }
		//     },
		//   };
		//   this.$util.request(params);
		// },
		setShowImg(value) {
			this.activeQuestion.scoreImg = value;
			let that = this;
			if (value == 'star') {
				that.imgUrlData.imgUrl = that.rateData[0].bgImg;
				that.imgUrlData.checkedImg = that.rateData[0].checkedImg;
				that.imgUrlData.unCheckedImg = that.rateData[0].unCheckedImg;
			} else if (value == 'heart') {
				that.imgUrlData.imgUrl = that.rateData[1].bgImg;
				that.imgUrlData.checkedImg = that.rateData[1].checkedImg;
				that.imgUrlData.unCheckedImg = that.rateData[1].unCheckedImg;
			} else if (value == 'smile') {
				that.imgUrlData.imgUrl = that.rateData[2].bgImg;
				that.imgUrlData.checkedImg = that.rateData[2].checkedImg;
				that.imgUrlData.unCheckedImg = that.rateData[2].unCheckedImg;
			} else if (value == 'thumb') {
				that.imgUrlData.imgUrl = that.rateData[3].bgImg;
				that.imgUrlData.checkedImg = that.rateData[3].checkedImg;
				that.imgUrlData.unCheckedImg = that.rateData[3].unCheckedImg;
			}
			this.showRateImgs = false;
		}
	},
	beforeRouteLeave(to, from, next) {
		let wid = sessionStorage.getItem('wid');
		if (this.paperReturnSuccess && wid) {
			this.submit();
		}
		clearTimeout(this.operationTimer);
		next();
	},
	beforeDestroy() {
		this.$store.commit('removeCitableQuesList');
		this.$store.commit('removeHtmlEditor');
	}
};
</script>

<style lang="scss" rel="stylesheet/scss">
.question-type {
	.exportImport {
		height: 60px;
		line-height: 60px;
		position: fixed;
		top: 0px;
		right: 90px;
		z-index: 999;
		.exportStyle {
			margin-right: 20px;
			font-size: 18px;
			cursor: pointer;
			color: #909399;
		}
		.exportStyle:hover {
			color: #000000;
		}
		.importStyle {
			font-size: 18px;
			cursor: pointer;
			color: #909399;
		}
		.importStyle:hover {
			color: #000000;
		}
	}
	div.wj-title {
		line-height: 44px;
		margin-top: 20px;
		// padding: 0 15px;
		background-color: #f1f1f1;
		border-radius: 3px;
		font-size: 18px;
		font-family: Arial;
		color: #606266;
	}
	.wenjuan_title {
		position: relative;
		line-height: 44px;
		margin-top: 20px;
		padding: 0 15px;
		background-color: #f1f1f1;
		border-radius: 3px;
		font-size: 18px;
		font-family: Arial;
		color: #606266;
		padding: 5px;
		margin-bottom: 15px;
		.editTitle {
			position: absolute;
			top: -35px;
			left: 0;
			padding: 10px;
			line-height: 1;
			background: #fff;
			box-shadow: 0 2px 12px 0 rgba(0, 0, 0, 0.1);
			font-size: 14px;
			color: #666;
			cursor: pointer;
			&:hover {
				color: #1896ff;
			}
		}
	}
	.wj-content {
		line-height: 38px;
		border-radius: 3px;
		border: 1px dashed #ccc;
		font-size: 16px;
		// padding: 0 15px;
		font-family: Arial;
		color: #606266;
		font-weight: 400;
	}
	.batchPopup {
		width: 540px;
		height: 310px;
		background: #ffffff;
		border-radius: 3px;
		position: absolute;
		z-index: 1111;
		top: 40%;
		left: 30%;
		box-shadow: 3px 3px 7px #000;
	}
	/deep/.welcomInput .el-input__inner {
		height: 38px !important;
		border-radius: 3px !important;
		border: dashed 1px #cccccc !important;
		font-size: 16px;
	}
	/deep/.titleInput .el-input__inner {
		/* width: 1080px !important; */
		height: 44px !important;
		background-color: #f1f1f1 !important;
		border-radius: 3px !important;
		margin-top: 20px !important;
		font-size: 18px;
	}
	.groupAdd {
		margin-right: 5px;
	}
	/deep/.groupRight_add .el-input__inner {
		width: 250px !important;
		height: 30px !important;
		background: #f8f8f8;
		margin-left: 10px;
	}
	/deep/.groupRight_add .el-input__inner:focus {
		border: 1px dashed #cccccc !important;
	}
	.groupRight_add {
		float: left;
		/* display:flex;
			justify-content: space-between;
			flex-wrap: wrap;
			align-items: center; */
		margin-top: 7px;
	}
	.groupRight_add .el-input {
		width: auto;
	}
	.groupRight_title {
		width: 100%;
		height: 40px;
		display: flex;
		align-items: center;
		justify-content: space-between;
	}
	.groupRight_title span {
		font-size: 14px;
	}
	.groupLeft_search {
		margin-top: 13px;
		margin-bottom: 15px;
	}
	/deep/.groupLeft_search .el-input__inner {
		border: 1px solid #e1e1e1 !important;
		background-color: #f7f7f7;
	}
	.groupLeft_Tips {
		font-size: 12px;
		color: #999999;
		margin-top: 10px;
	}
	.groupLeft_title {
		font-size: 14px;
		color: #333333;
		margin-top: 13px;
	}
	.group_btnBox {
		margin-top: 20px;
		margin-left: 328px;
	}
	.groupBox {
		width: 100%;
		height: 320px;
		display: flex;
		justify-content: space-between;
	}
	.groupLeft {
		width: 380px;
		height: 315px;
		background: #f9fcff;
		border-radius: 3px;
		border: 1px solid #e1e1e1;
		margin-left: 10px;
	}
	.groupRight {
		width: 380px;
		height: 315px;
		background-color: #f8f8f8;
		border-radius: 3px;
		border: solid 1px #e1e1e1;
		margin-right: 10px;
	}
	.groupTitle {
		width: 100%;
		height: 60px;
		display: flex;
		align-items: center;
		justify-content: space-between;
		/* border:1px solid red; */
	}
	.groupTitle i {
		font-size: 20px;
		margin-right: 15px;
	}
	/deep/.disconditions .el-input__inner {
		width: 80px !important;
		height: 30px !important;
		line-height: 30px !important;
	}
	.disconditions {
		margin-top: 16px;
		font-size: 14px;
		color: #666666;
	}

	.heade {
		padding: 0px 4px;
		border: 1px solid #ccc;
		cursor: pointer;
	}
	.activeCheck {
		border: 1px solid #0080ff !important;
		color: #0080ff;
	}
	.wjType {
		width: 300px;
		float: right;
		display: inline;
		background-color: #fff;
	}
	.heiSetting-box {
		min-height: 49px;
		line-height: 49px;
		border-bottom: 1px solid #ccc;
		font-size: 14px;
		.switch-box,
		.item-box {
			display: flex;
			align-items: center;
			justify-content: space-between;
		}
	}
	.heiSetting {
		min-height: 49px;
		line-height: 49px;
		border-bottom: 1px solid #ccc;
		font-size: 14px;
		display: flex;
		justify-content: space-between;
		.switch-box,
		.item-box {
			display: flex;
			align-items: center;
			justify-content: space-between;
		}
		.item-box {
			color: #707070;
		}
		.item-box .el-input {
			width: 100px;
		}
		.heiSetting_right_lk {
			float: right;
			.heiSetting_right_lk_inp {
				width: 66px;
				.el-input__inner {
					height: 24px;
					margin-right: 5px;
				}
			}
			.heiSetting_right_lk_dropdown {
				width: 95px;
				margin-left: 10px;
				.el-input__inner {
					height: 24px;
				}

				text-align: center;
			}
		}
		// &::after {
		// 	content: '';
		// 	clear: both;
		// }
		.short-input {
			width: 80px;
			margin-right: 5px;
		}
		.label {
			height: 24px;
			padding-top: 5px;
			// color: #707070;
			font-size: 13px;
			line-height: 24px;
		}
	}
	// .left {
	// 	float: left;
	// 	/*margin-left: 6px;*/
	// }
	// .right {
	// 	float: right;
	// }
	.tab_layout span {
		padding: 1px 7px;
		border: 1px solid #ccc;
		cursor: pointer;
	}
	/deep/.right .el-input__inner {
		width: 94px !important;
		height: 24px !important;
		border: 1px solid #ccc !important;
	}
	.mask {
		position: fixed;
		left: 0;
		top: 0;
		z-index: 1001;
		width: 100%;
		height: 100%;
		background-color: #000;
		opacity: 0.3;
	}
	.details2 {
		/* // 遮罩层内容 */
		position: fixed;
		background: #fff;
		width: 800px;
		height: auto;
		overflow: auto;
		opacity: 1;
		z-index: 2001;
		top: 20%; /*偏移*/
		left: 45%;
		max-height: 300px;
		margin-left: -300px;
	}
	.details4 {
		position: fixed;
		background: #fff;
		width: 800px;
		min-height: 230px;
		overflow: auto;
		opacity: 1;
		z-index: 2001;
		top: 20%; /*偏移*/
		left: 43%;
		margin-left: -300px;
	}
	.details3 {
		/* // 遮罩层内容 */
		position: fixed;
		background: #fff;
		width: 800px;
		height: 460px;
		overflow: auto;
		opacity: 1;
		z-index: 2001;
		top: 20%; /*偏移*/
		left: 45%;
		margin-left: -300px;
	}
	.details {
		/* // 遮罩层内容 */
		position: fixed;
		background: #fff;
		width: 800px;
		height: 580px;
		overflow: auto;
		opacity: 1;
		z-index: 2001;
		top: 20%; /*偏移*/
		left: 45%;
		margin-left: -300px;
	}
	.details-1 {
		width: 100%;
		height: 60px;
		line-height: 60px;
		background: #fff;
		position: relative;
		color: #333;
		border-bottom: 1px solid #0080ff;
		font-size: 18px;
		text-align: center;
	}
	.details-1 i {
		color: #999;
		position: absolute;
		right: 20px;
		top: 34%;
	}
	.import_box {
		width: 100%;
		min-height: 150px;
		background: #fff;
		margin-top: 20px;
	}
	.option_content {
		width: 100%;
		height: 178px;
		background-color: #f8f8f8;
	}
	/deep/.konginput .el-input {
		background: #f8f8f8 !important;
	}
	.table_option {
		width: 100%;
		height: 250px;
		background-color: #f9fcff;
	}
	/deep/.selectLength.el-select .el-input__inner {
		width: 90px !important;
		height: 24px !important;
		border: 1px solid #ccc !important;
	}
	/deep/.hengInput .el-input__inner {
		width: 65px !important;
		height: 24px !important;
		border: 1px solid #ccc;
	}
	/deep/.choiceQuestion .el-input__inner {
		width: 140px !important;
		border: 1px solid #ccc !important;
	}
	.choiceQuestion .conditionsInput {
		width: 80px;
	}
	/deep/.labelClass .el-input__inner {
		width: 140px !important;
	}
	.choiceQuestion {
		.el-select + .el-select {
			margin-left: 14px;
		}
	}

	.icon_num i {
		font-size: 20px;
		color: #ccc;
		margin-left: 10px;
		float: left;
	}
	/deep/.optionClass .el-input__inner {
		width: 140px !important;
	}
	/deep/.range .el-input__inner {
		width: 77px;
		height: 24px;
		margin-left: 2px;
	}
	.operate_item {
		height: 60px;
		line-height: 60px;
		width: 90%;
		margin: 0px auto;
		overflow: hidden;
		white-space: nowrap;
		text-overflow: ellipsis;
	}
	.display_inline {
		display: inline;
		float: left;
		height: 68px;
		line-height: 68px;
	}

	.wjTitle > input {
		border: 0px !important;
		text-align: center;
	}
	.item_container_hover {
		border: 2px #409eff solid;
		border-radius: 3px;
	}
	.item_container {
		font-size: 14px;
		margin-top: 8px;
		background-color: #fff;
		margin-left: 0px !important;
		margin-right: 0px !important;
		padding-top: 6px;
		padding-bottom: 6px;
		// .el-tiptap-editor > .el-tiptap-editor__content {
		// 	color: #606266;
		// }
	}
	.operate_td {
		width: 30px;
		height: 30px;
		font-size: 26px;
		background-color: cornflowerblue;
		text-align: center;
		line-height: 30px;
	}
	.qtypeItem {
		text-align: center;
		display: inline;
		float: left;
		width: 80px;
		height: 80px;
		border: 1px solid #eaeaea;
	}
	.wjTypeChildItemFont {
		font-size: 14px;
		cursor: pointer;
	}
	.wjTypeChildQuestion {
		max-height: calc(100vh - 103px);
		overflow-y: auto;
		margin-left: 2px;
		max-width: 250px;
		background-color: #fff;
		position: fixed;
		padding: 20px;
	}
	/*题库*/
	.tk_item {
		width: 250px;
		height: 69px;
		margin: 0 auto;
		border-bottom: 1px solid #d5d5d6;
	}

	/deep/.el-tabs__nav-wrap::after {
		background-color: #ffffff !important;
	}
	.jumpDetail {
		width: 770px;
		height: auto;
		margin: 0 auto;
		margin-top: 10px;
	}
	.jumpDetail .el-input__inner {
		border: 1px solid #cccccc !important;
	}
	.jumpDetail .el-input__inner:hover {
		border: 1px solid #cccccc !important;
	}
	// 有啥用？
	// .el-input__inner:hover {
	// 	border: none !important;
	// }
	.groupLeft .el-checkbox {
		width: 100%;
	}
	.groupLeft .el-checkbox__label {
		width: 100%;
		overflow: hidden;
		text-overflow: ellipsis;
		vertical-align: top;
	}
	.drag-container {
		padding-bottom: 24px;
	}
	.drag-container .ghost {
		opacity: 1;
	}
}
.tipsTxtBox {
	border-bottom: 1px solid #ccc;
	font-size: 14px;
	line-height: 1;
	.tipsTitle {
		display: block;
		margin: 20px 0;
	}
	.tipsTxt {
		.itemBox {
			display: flex;
			justify-content: space-between;
			padding: 3px 0;
			.input {
				width: 100px;
			}
		}
	}
}
.showStyle {
	display: flex;
	justify-content: space-between;
	align-items: center;
	border-bottom: 1px solid #ccc;
	height: 49px;
	line-height: 1;
	.left {
		font-size: 14px;
	}
	.right {
		width: 100px;
		height: 32px;
		border: 1px solid #ccc;
		position: relative;
		.showUl {
			position: absolute;
			top: 33px;
			left: -1px;
			z-index: 10;
			border: 1px solid #ccc;
			li {
				width: 100%;
				height: 32px;
				text-align: center;
				border-bottom: 1px solid #ccc;
				background-color: #fff;
				// padding: 0 10px;
				display: flex;
				align-items: center;
				&:hover {
					background: #1790f3;
				}
				img {
					width: 100%;
				}
			}
		}
	}
}
.submit-btn {
	text-align: center;
	position: fixed;
	padding-bottom: 20px;
	background-color: #fff;
	bottom: 0;
	z-index: 1002;
	.submit-exam {
		width: 100%;
		margin-top: 20px;
	}
}
.buttom {
	cursor: pointer;
}
</style>
<style lang="scss">
/* 试题组件 */
.question-box {
	margin: 15px 0px 0px 5px !important;

	.askxh {
		line-height: 30px;
		text-align: right;
	}
	.item_container_title {
		padding-left: 15px !important;
		padding-right: 0px !important;
	}
	.delete,
	.item {
		font-size: 18px !important;
		line-height: 30px !important;
		margin-right: 15px;
		text-align: right;
		float: right;
		cursor: pointer;
	}
}
</style>
<style scoped lang="scss">
.logical-settings /deep/.el-dialog,
.option-association /deep/.el-dialog {
	width: 860px !important;
}
.logical-setAppoint /deep/.el-dialog {
	width: 576px !important;
}
.wjpc-iconfont {
	cursor: pointer;
	font-size: 12px;
	margin-left: 5px;
	color: #aaa;
}
.questionType {
	margin-top: 62px;
	margin-left: 80px;
	display: flex;
}
.test-edit {
	width: 100%;
}

.aside {
	max-height: calc(100vh - 60px);
	width: 290px;
	box-shadow: 0 2px 8px 0 rgba(0, 0, 0, 0.16);
	position: fixed;
	background-color: rgb(255, 255, 255);
	box-sizing: border-box;
	z-index: 1;
	.fixedSearch {
		margin-bottom: 10px;
	}
	.fixedTabsIcon-box {
		display: flex;
		justify-content: end;
		align-items: center;
		i {
			display: inline-block;
			font-size: 18px;
			color: #999;
			cursor: pointer;
			margin-left: 10px;
		}
	}
	.fixedTabs {
		width: 260px;
		max-height: calc(100vh - 60px);
		overflow-y: auto;
		z-index: 2;
		// padding-rigth:10px;k
		box-sizing: border-box;
		padding-bottom: 50px;
	}
	.fixedTabs::-webkit-scrollbar {
		display: none;
	}
	// 大纲显示滚动条
	.fixedTabsThird{
		width: 260px;
		max-height: calc(100vh - 60px);
		overflow-y: auto;
		z-index: 2;
		// padding-rigth:10px;k
		box-sizing: border-box;
		padding-bottom: 50px;
	}
	.fixedTabsThird::-webkit-scrollbar {
		// display: none;
	}
}
</style>
